export const ApsDataService = {
    data: [
        {en: 'Abbeyhill Dr & Eagleson Rd', fr: 'Prom. Abbeyhill et Ch. Eagleson', aoda: false},
        {en: 'Abbott St & Stittsville Main St', fr: 'Rue Abbott et Rue Stittsville Main', aoda: true},
        {en: 'Aberdeen Dr & Rochester St', fr: 'Aberdeen Dr et Rue Rochester', aoda: false},
        {en: 'Abetti Ridge & Jockvale Rd', fr: 'Côte Abetti et Ch. Jockvale', aoda: false},
        {
            en: 'Aero Dr / Creek\'S End Ln & Holly Acres Rd',
            fr: 'Prom. Aero / Rle Creek\'S End et Ch. Holly Acres',
            aoda: false,
        },
        {en: 'Ages Rd & Hawthorne Rd', fr: 'Ch. Ages et Ch. Hawthorne', aoda: false},
        {
            en: 'Aird Place & Castlefrank Rd / Kanata Ave',
            fr: 'Place Aird et Ch. Castlefrank / Av. Kanata',
            aoda: false,
        },
        {en: 'Aird Place/Chimo Drive & Katimavik Rd', fr: 'Place Aird/Prom. Chimo et Ch. Katimavik', aoda: false},
        {
            en: 'Airport Pkwy N/B On/Off Ramp /Alert Rd & Lester Rd /Uplands Dr',
            fr: 'Bretelle Entrée/Sortie Dir. N. Prom. De L\'Aéroport /Ch. Alert et Ch. Lester /Prom. Uplands',
            aoda: false,
        },
        {
            en: 'Airport Pkwy S/B Off Ramp & Uplands Dr',
            fr: 'Bretelle De Sortie Dir. S. Prom. De L\'Aéroport et Prom. Uplands',
            aoda: false,
        },
        {
            en: 'Airport Pkwy/Transitway Ramp & Walkley Rd',
            fr: 'Prom. De L\'Aéroport/Bretelle Du Transitway et Ch. Walkley',
            aoda: false,
        },
        {en: 'Albert & City Centre', fr: 'Rue Albert et City Centre', aoda: false},
        {en: 'Albert & 105M S Of Commissioner', fr: 'Rue Albert et 105 M Sud De Commissioner', aoda: false},
        {en: 'Albert St & Lyon St N', fr: 'Rue Albert et Rue Lyon N.', aoda: false},
        {en: 'Albert St & Preston St', fr: 'Rue Albert et Rue Preston', aoda: false},
        {en: 'Albert St & Bay St', fr: 'Rue Albert et Rue Bay', aoda: true},
        {en: 'Albert St & O\'Connor St', fr: 'Rue Albert et Rue O\'Connor', aoda: false},
        {en: 'Albert St & Metcalfe St', fr: 'Rue Albert et Rue Metcalfe', aoda: false},
        {en: 'Albert St & Kent St', fr: 'Rue Albert et Rue Kent', aoda: true},
        {en: 'Albert St & Bank St', fr: 'Rue Albert et Rue Bank', aoda: false},
        {en: 'Albert St & Booth St', fr: 'Rue Albert et Rue Booth', aoda: false},
        {en: 'Albert St /Scott St & Bayview Rd', fr: 'Rue Albert /Rue Scott et Ch. Bayview', aoda: false},
        {
            en: 'Albert St /Slater St & Empress Ave/ Transitway W',
            fr: 'Rue Albert /Rue Slater et Av. Empress/ Transitway O.',
            aoda: false,
        },
        {
            en: 'Albert St / Mckenzie King Bridge & Elgin St',
            fr: 'Rue Albert / Pont Mckenzie King et Rue Elgin',
            aoda: false,
        },
        {en: 'Albion Rd & Hunt Club Rd', fr: 'Ch. Albion et Ch. Hunt Club', aoda: false},
        {en: 'Albion Rd & Bridle Path Dr', fr: 'Ch. Albion et Prom. Bridle Path', aoda: false},
        {
            en: 'Albion Rd & Recreation Path / 118M S Of Brenda Cres',
            fr: 'Ch. Albion et Sentier Récréatif / 118 M Sud Du Crois. Brenda',
            aoda: false,
        },
        {en: 'Albion Rd & D\'Aoust Ave', fr: 'Ch. Albion et Av. D\'Aoust', aoda: false},
        {en: 'Albion Rd & Lester Rd', fr: 'Ch. Albion et Ch. Lester', aoda: false},
        {en: 'Albion Rd & Mitch Owens Rd', fr: 'Ch. Albion et Ch. Mitch Owens', aoda: false},
        {en: 'Albion Rd & Findlay Creek Dr', fr: 'Ch. Albion et Prom. Findlay Creek', aoda: false},
        {en: 'Albion Rd / Colliston St & Walkley Rd', fr: 'Ch. Albion / Rue Colliston et Ch. Walkley', aoda: false},
        {en: 'Allen Blvd & Mcarthur Ave', fr: 'Boul. Allen et Av. Mcarthur', aoda: false},
        {en: 'Alpine Ave & Carling Ave', fr: 'Av. Alpine et Av. Carling', aoda: false},
        {en: 'Alta Vista Dr & Pleasant Park Rd', fr: 'Prom. Alta Vista et Ch. Pleasant Park', aoda: false},
        {en: 'Alta Vista Dr & Kilborn Ave', fr: 'Prom. Alta Vista et Av. Kilborn', aoda: false},
        {
            en: 'Alta Vista Dr & Pedestrian Signal / 75M S Of Caledon St',
            fr: 'Prom. Alta Vista et Feu Pour Piétons / 75 M Sud De La Rue Caledon',
            aoda: false,
        },
        {en: 'Alta Vista Dr & Heron Rd', fr: 'Prom. Alta Vista et Ch. Heron', aoda: false},
        {en: 'Alta Vista Dr & Ridgemont Ave', fr: 'Prom. Alta Vista et Av. Ridgemont', aoda: false},
        {en: 'Alta Vista Dr & Hospital Link', fr: 'Prom. Alta Vista et Tronçon Vers L\'Hôpital', aoda: true},
        {en: 'Amberwood & Merivale Rd', fr: 'Amberwood et Ch. Merivale', aoda: false},
        {en: 'Amiens St & Tenth Line Rd', fr: 'Rue Amiens et Ch. Tenth Line', aoda: false},
        {en: 'Andora Rd & Strandherd Dr', fr: 'Ch. Andora et Prom. Strandherd', aoda: false},
        {en: 'Anthony Ave & Woodroffe Ave', fr: 'Av. Anthony et Av. Woodroffe', aoda: false},
        {en: 'Appleford St & Ogilvie Rd', fr: 'Rue Appleford et Ch. Ogilvie', aoda: false},
        {en: 'Arena Rd / Hawkstone Gt & Campeau Dr', fr: 'Ch. Arena / Porte Hawkstone et Prom. Campeau', aoda: false},
        {en: 'Argyle Ave & O\'Connor St', fr: 'Av. Argyle et Rue O\'Connor', aoda: true},
        {en: 'Argyle Ave & Metcalfe St', fr: 'Av. Argyle et Rue Metcalfe', aoda: false},
        {en: 'Arlington Ave & Kent St', fr: 'Av. Arlington et Rue Kent', aoda: false},
        {en: 'Arlington Ave & Bronson Ave', fr: 'Av. Arlington et Av. Bronson', aoda: false},
        {en: 'Armstrong St & Parkdale Ave', fr: 'Rue Armstrong et Av. Parkdale', aoda: true},
        {en: 'Arthur St & Gladstone Ave', fr: 'Rue Arthur et Av. Gladstone', aoda: false},
        {en: 'Arthur St & Somerset St W', fr: 'Rue Arthur et Rue Somerset O.', aoda: true},
        {
            en: 'Ashgrove Cres/Harrison St & Greenbank Rd',
            fr: 'Crois. Ashgrove /Rue Harrison et Ch. Greenbank',
            aoda: false,
        },
        {en: 'Assaly Rd & Richmond Rd', fr: 'Ch. Assaly et Ch. Richmond', aoda: true},
        {en: 'Athlone Ave & Richmond Rd', fr: 'Av. Athlone et Ch. Richmond', aoda: false},
        {en: 'Athlone Ave & Scott St', fr: 'Av. Athlone et Rue Scott', aoda: false},
        {en: 'Augusta St & Rideau St', fr: 'Rue Augusta et Rue Rideau', aoda: false},
        {en: 'Aviation Pkwy & Montreal Rd', fr: 'Prom. De L\'Aviation et Ch. De Montréal', aoda: true},
        {en: 'Aviation Pkwy & Ogilvie Rd', fr: 'Prom. De L\'Aviation et Ch. Ogilvie', aoda: false},
        {en: 'Avoncourt Way & Walkley Rd', fr: 'Voie Avoncourt et Ch. Walkley', aoda: true},
        {en: 'Aylmer Ave & Bank St', fr: 'Av. Aylmer et Rue Bank', aoda: false},
        {en: 'Bank St & Fifth Ave', fr: 'Rue Bank et Av. Fifth', aoda: false},
        {en: 'Bank St & First Ave', fr: 'Rue Bank et Av. First', aoda: false},
        {en: 'Bank St & Glebe Ave', fr: 'Rue Bank et Av. Glebe', aoda: false},
        {en: 'Bank St & Sunnyside Ave', fr: 'Rue Bank et Av. Sunnyside', aoda: false},
        {en: 'Bank St & Gilmour St', fr: 'Rue Bank et Rue Gilmour', aoda: false},
        {en: 'Bank St & Gladstone Ave', fr: 'Rue Bank et Av. Gladstone', aoda: false},
        {en: 'Bank St & Cameron Ave', fr: 'Rue Bank et Av. Cameron', aoda: false},
        {en: 'Bank St & Holmwood Ave', fr: 'Rue Bank et Av. Holmwood', aoda: false},
        {en: 'Bank St & Slater St', fr: 'Rue Bank et Rue Slater', aoda: false},
        {en: 'Bank St & Riverdale Ave', fr: 'Rue Bank et Av. Riverdale', aoda: false},
        {en: 'Bank St & Riverside Dr N', fr: 'Rue Bank et Prom. Riverside N.', aoda: false},
        {en: 'Bank St & Laurier Ave W', fr: 'Rue Bank et Av. Laurier O.', aoda: false},
        {en: 'Bank St & Belmont Ave / Glen Ave', fr: 'Rue Bank et Av. Belmont / Av. Glen', aoda: false},
        {en: 'Bank St & Third Ave', fr: 'Rue Bank et Av. Third', aoda: false},
        {en: 'Bank St & Kitchener Ave', fr: 'Rue Bank et Av. Kitchener', aoda: false},
        {
            en: 'Bank St & Johnston Rd / Greenboro Transit Stn',
            fr: 'Rue Bank et Ch. Johnston / Station Greenboro',
            aoda: true,
        },
        {en: 'Bank St & Belanger Ave / Kilborn Ave', fr: 'Rue Bank et Av. Belanger / Av. Kilborn', aoda: false},
        {en: 'Bank St & Lisgar St', fr: 'Rue Bank et Rue Lisgar', aoda: false},
        {en: 'Bank St & Queen St', fr: 'Rue Bank et Rue Queen', aoda: true},
        {en: 'Bank St & Randall', fr: 'Rue Bank et Av. Randall', aoda: false},
        {en: 'Bank St & Heron Rd', fr: 'Rue Bank et Ch. Heron', aoda: false},
        {en: 'Bank St & Riverside Dr S', fr: 'Rue Bank et Prom. Riverside S.', aoda: false},
        {en: 'Bank St & Sparks St', fr: 'Rue Bank et Rue Sparks', aoda: false},
        {en: 'Bank St & Somerset St W', fr: 'Rue Bank et Rue Somerset O.', aoda: false},
        {en: 'Bank St & Wellington St', fr: 'Rue Bank et Rue Wellington', aoda: false},
        {en: 'Bank St & Chamberlain Ave / Isabella St', fr: 'Rue Bank et Av. Chamberlain / Rue Isabella', aoda: false},
        {en: 'Bank St & Hunt Club Rd', fr: 'Rue Bank et Ch. Hunt Club', aoda: false},
        {en: 'Bank St & Flora St', fr: 'Rue Bank et Rue Flora', aoda: false},
        {en: 'Bank St & Cahill Dr / Daze Dr.', fr: 'Rue Bank et Prom. Cahill / Prom. Daze.', aoda: false},
        {en: 'Bank St & Gloucester St', fr: 'Rue Bank et Rue Gloucester', aoda: false},
        {en: 'Bank St & Strathcona Ave', fr: 'Rue Bank et Av. Strathcona', aoda: false},
        {en: 'Bank St & Maclaren St', fr: 'Rue Bank et Rue Marue Claren', aoda: false},
        {
            en: 'Bank St & Billings Bridge Terminal/180M S Of Riverside Dr',
            fr: 'Rue Bank et Station Billings Bridge / 180 M Sud De Prom. Riverside',
            aoda: false,
        },
        {
            en: 'Bank St & Pedestrian Signal / 75M N Of Evans Blvd',
            fr: 'Rue Bank et Feu Pour Piétons / 75 M Nord Du Boul. Evans',
            aoda: false,
        },
        {en: 'Bank St & Erie Ave', fr: 'Rue Bank et Av. Erie', aoda: true},
        {
            en: 'Bank St & Lansdowne Park N Ent/ 140M S Of Holmwood Ave',
            fr: 'Rue Bank et Entrée N. Du Parc Lansdowne / 140 M Sud De L\'Av. Holmwood',
            aoda: false,
        },
        {
            en: 'Bank St & South Keys Sc/ 345M N Of Cahill/ Daze St.',
            fr: 'Rue Bank et C.C. South Keys / 345 M Nord De Prom. Cahill / Rue Daze',
            aoda: false,
        },
        {en: 'Bank St & Queensdale Ave', fr: 'Rue Bank et Av. Queensdale', aoda: false},
        {en: 'Bank St & Leitrim Rd', fr: 'Rue Bank et Ch. Leitrim', aoda: true},
        {
            en: 'Bank St & Towngate Sc / 80M S Of Hunt Club Rd',
            fr: 'Rue Bank et C.C. Towngate / 80 M Sud Du Ch. Hunt Club',
            aoda: true,
        },
        {en: 'Bank St & St Bernard St', fr: 'Rue Bank et St Rue Bernard', aoda: false},
        {en: 'Bank St & Findlay Creek Dr', fr: 'Rue Bank et Prom. Findlay Creek', aoda: false},
        {en: 'Bank St & Parkway Rd', fr: 'Rue Bank et Ch. Parkway', aoda: false},
        {
            en: 'Bank St & White Alder Ave / Analdea Dr,',
            fr: 'Rue Bank et Av. White Alder / Prom. Analdea',
            aoda: false,
        },
        {
            en: 'Bank St & 680M N Of Conroy Rd / Ncc Pathway',
            fr: 'Rue Bank et 680 M Nord Du Ch. Conroy / Sentier De La Ccn',
            aoda: false,
        },
        {
            en: 'Bank St & Findlay Creek Shopping Centre',
            fr: 'Rue Bank et Centre Commercial Findlay Creek',
            aoda: false,
        },
        {
            en: 'Bank St & Rotary Way / 420M S Of Leitrim Rd',
            fr: 'Rue Bank et Voie Rotary / 420 M Sud Du Ch. Leitrim',
            aoda: false,
        },
        {
            en: 'Bankfield Rd & Manotick Main / Rideau Valley',
            fr: 'Ch. Bankfield et Rue Manotick Main / Prom. Rideau Valley',
            aoda: false,
        },
        {en: 'Banton Street & Walkley Rd', fr: 'Rue Banton et Ch. Walkley', aoda: false},
        {en: 'Baseline Rd & Clyde Ave', fr: 'Ch. Baseline et Av. Clyde', aoda: false},
        {en: 'Baseline Rd & Fisher Ave', fr: 'Ch. Baseline et Av. Fisher', aoda: false},
        {en: 'Baseline Rd & Navaho Dr', fr: 'Ch. Baseline et Prom. Navaho', aoda: false},
        {en: 'Baseline Rd & Greenbank Rd', fr: 'Ch. Baseline et Ch. Greenbank', aoda: false},
        {en: 'Baseline Rd & Merivale Rd', fr: 'Ch. Baseline et Ch. Merivale', aoda: false},
        {en: 'Baseline Rd & Woodroffe Ave', fr: 'Ch. Baseline et Av. Woodroffe', aoda: true},
        {en: 'Baseline Rd & Ferguson St', fr: 'Ch. Baseline et Rue Ferguson', aoda: true},
        {en: 'Baseline Rd & Guthrie St', fr: 'Ch. Baseline et Rue Guthrie', aoda: false},
        {
            en: 'Baseline Rd & Centrepointe Dr / Highgate Rd',
            fr: 'Ch. Baseline et Prom. Centrepointe / Ch. Highgate',
            aoda: false,
        },
        {
            en: 'Baseline Rd & Loblaws/ 375 M W Of Merivale',
            fr: 'Ch. Baseline et Loblaws / 375 M Ouest Du Ch. Merivale',
            aoda: false,
        },
        {en: 'Baseline Rd & Cedarview Rd', fr: 'Ch. Baseline et Ch. Cedarview', aoda: true},
        {en: 'Baseline Rd & Sandcastle Dr', fr: 'Ch. Baseline et Prom. Sandcastle', aoda: false},
        {en: 'Baseline Rd & Farlane Blvd', fr: 'Ch. Baseline et Boul. Farlane', aoda: false},
        {
            en: 'Baseline Rd & Q/Way Carleton Hosp/180M E Of Cedarview',
            fr: 'Ch. Baseline et Hôpital Queensway Carleton / 180 M Est Du Ch. Cedarview',
            aoda: false,
        },
        {en: 'Baseline Rd & Monterey Dr', fr: 'Ch. Baseline et Prom. Monterey', aoda: false},
        {en: 'Baseline Rd & Cordova St', fr: 'Ch. Baseline et Rue Cordova', aoda: false},
        {
            en: 'Baseline Rd & College Square / 220M E Of Woodroffe Ave',
            fr: 'Ch. Baseline et College Square / 220 M Est De L\'Av. Woodroffe',
            aoda: false,
        },
        {en: 'Baseline Rd & Constellation Cr.', fr: 'Ch. Baseline et Crois. Constellation.', aoda: false},
        {
            en: 'Baseline Rd & 300M E Of Clyde / Walmart',
            fr: 'Ch. Baseline et 300 M Est De L\'Av. Clyde / Walmart',
            aoda: false,
        },
        {
            en: 'Baseline Rd /Heron Rd & Prince Of Wales Dr',
            fr: 'Ch. Baseline /Ch. Heron et Prom. Prince Of Wales',
            aoda: false,
        },
        {en: 'Bathgate Dr/Burma Road & Montreal Rd', fr: 'Prom. Bathgate/Ch. Burma et Ch. De Montréal', aoda: false},
        {en: 'Bathgate Dr/City Park Dr & Ogilvie Rd', fr: 'Prom. Bathgate/Prom. City Park et Ch. Ogilvie', aoda: true},
        {en: 'Bay St & Slater St', fr: 'Rue Bay et Rue Slater', aoda: true},
        {en: 'Bay St & Laurier Ave W', fr: 'Rue Bay et Av. Laurier O.', aoda: true},
        {en: 'Bay St & Wellington St', fr: 'Rue Bay et Rue Wellington', aoda: false},
        {en: 'Bay St & Sparks St.', fr: 'Rue Bay et Rue Sparks.', aoda: false},
        {en: 'Baycrest Dr & Walkley Rd', fr: 'Prom. Baycrest et Ch. Walkley', aoda: true},
        {en: 'Bayshore Dr & Woodridge Cres S', fr: 'Prom. Bayshore et Woodridge Cres S', aoda: false},
        {
            en: 'Bayshore Dr & 205M N Of Woodridge (South)',
            fr: 'Prom. Bayshore et 205 M Nord Du Crois. Woodridge (Sud)',
            aoda: false,
        },
        {en: 'Bayshore Dr & Woodridge Cres N', fr: 'Prom. Bayshore et Crois. Woodridge N.', aoda: false},
        {
            en: 'Bayshore Dr/Birchdale Ave & Carling Ave',
            fr: 'Prom. Bayshore/Av. Birchdale et Av. Carling',
            aoda: false,
        },
        {
            en: 'Bayshore Dr/Hwy 417 Wb Off Ramp & Richmond Rd',
            fr: 'Prom. Bayshore / Bretelle De Sortie Autoroute 417 O. et Ch. Richmond',
            aoda: false,
        },
        {en: 'Bayswater Ave & Gladstone Ave', fr: 'Av. Bayswater et Av. Gladstone', aoda: false},
        {en: 'Bayswater Ave & Somerset St W', fr: 'Av. Bayswater et Rue Somerset O.', aoda: false},
        {en: 'Bearbrook Rd & Westpark Dr N', fr: 'Ch. Bearbrook et Prom. Westpark N.', aoda: false},
        {
            en: 'Bearbrook Rd & Pedestrian Signal / 43M S Of Centrepark Dr',
            fr: 'Ch. Bearbrook et Feu Pour Piétons / 43 M Sud De La Prom. Centrepark',
            aoda: false,
        },
        {
            en: 'Bearbrook Rd & Rec. Path / 60M S Of Westpark Dr.',
            fr: 'Ch. Bearbrook et Sentier Récréatif / 60 M Sud De La Prom. Westpark.',
            aoda: true,
        },
        {en: 'Bearbrook Rd/Glen Park Dr & Innes Rd', fr: 'Ch. Bearbrook/Prom. Glen Park et Ch. Innes', aoda: false},
        {en: 'Beatrice Dr & Strandherd Dr', fr: 'Prom. Beatrice et Prom. Strandherd', aoda: false},
        {en: 'Beatrice Dr & Chapman Mills Dr', fr: 'Prom. Beatrice et Prom. Chapman Mills', aoda: false},
        {en: 'Beausejour Dr N & Orleans Blvd', fr: 'Prom. Beauséjour N. et Boul. Orléans', aoda: false},
        {
            en: 'Beausejour/Maple Run & Orleans Blvd',
            fr: 'Prom. Beauséjour / Av. Maple Run et Boul. Orléans',
            aoda: false,
        },
        {
            en: 'Beaverbrook Rd/Penfield Dr & Teron Rd',
            fr: 'Ch. Beaverbrook / Prom. Penfield et Ch. Teron',
            aoda: false,
        },
        {en: 'Beaverpond & Blair Rd', fr: 'Prom. Beaverpond et Ch. Blair', aoda: false},
        {en: 'Beckwith / Bower St & Main St', fr: 'Ch. Beckwith / Rue Bower et Rue Main', aoda: true},
        {en: 'Beech St & Preston St', fr: 'Rue Beech et Rue Preston', aoda: false},
        {
            en: 'Beechwood Ave & Crichton St/Vanier Pkwy',
            fr: 'Av. Beechwood et Rue Crichton / Prom. Vanier',
            aoda: false,
        },
        {en: 'Beechwood Ave & St Charles St', fr: 'Av. Beechwood et Rue St-Charles', aoda: false},
        {en: 'Beechwood Ave & Springfield Rd', fr: 'Av. Beechwood et Ch. Springfield', aoda: false},
        {
            en: 'Beechwood Ave & Charlevoix St/ Mackay St',
            fr: 'Av. Beechwood et Rue Charlevoix / Rue Mackay',
            aoda: true,
        },
        {en: 'Belcourt Blvd & St Joseph Blvd', fr: 'Boul. Belcourt et Boul. St-Joseph', aoda: false},
        {en: 'Belfast Rd & Tremblay Rd', fr: 'Ch. Belfast et Ch. Tremblay', aoda: true},
        {en: 'Belfast Rd & St Laurent Blvd', fr: 'Ch. Belfast et Boul. St-Laurent', aoda: false},
        {en: 'Belfast Rd & Coventry Rd', fr: 'Ch. Belfast et Ch. Coventry', aoda: false},
        {en: 'Belfast Rd & Oc Transpo Access', fr: 'Ch. Belfast et Accès À Oc Transpo', aoda: false},
        {en: 'Belfast Rd & Trainyard Dr.', fr: 'Ch. Belfast et Prom. Trainyard.', aoda: false},
        {en: 'Bentley Ave/Camelot Dr & Merivale Rd', fr: 'Av. Bentley/Prom. Camelot et Ch. Merivale', aoda: false},
        {en: 'Berrigan Dr & Sw Transitway', fr: 'Prom. Berrigan et Transitway S.-O.', aoda: false},
        {en: 'Berrigan Dr/Wessex Rd & Greenbank Rd', fr: 'Prom. Berrigan / Ch. Wessex et Ch. Greenbank', aoda: true},
        {en: 'Besserer St & King Edward Ave', fr: 'Rue Besserer et Av. King Edward', aoda: false},
        {en: 'Besserer St & Cumberland St', fr: 'Rue Besserer et Rue Cumberland', aoda: false},
        {en: 'Besserer St & Dalhousie St', fr: 'Rue Besserer et Rue Dalhousie', aoda: true},
        {
            en: 'Besserer St / Rideau Centre Ent & Nicholas St',
            fr: 'Rue Besserer / Centre Rideau Ent et Rue Nicholas',
            aoda: true,
        },
        {en: 'Beverley St & Stittsville Main St', fr: 'Rue Beverley et Rue Stittsville Main', aoda: false},
        {en: 'Bilberry Dr & Jeanne D\'Arc Blvd W', fr: 'Prom. Bilberry et Boul. Jeanne-D\'Arc O.', aoda: false},
        {en: 'Birch Ave & Hemlock Rd', fr: 'Av. Birch et Ch. Hemlock', aoda: false},
        {en: 'Blackburn Bypass & Navan Rd', fr: 'Rocade Blackburn et Ch. Navan', aoda: true},
        {
            en: 'Blackburn Bypass & Recreation Path / 1700M W Of Rr028 (Navan Rd)',
            fr: 'Rocade Blackburn et Sentier Récréatif / 1700 M Ouest De Rr028 (Ch. Navan)',
            aoda: false,
        },
        {en: 'Blackburn Bypass East & Innes Rd', fr: 'Rocade Blackburn East et Ch. Innes', aoda: false},
        {en: 'Blair Rd & Innes Rd', fr: 'Ch. Blair et Ch. Innes', aoda: false},
        {en: 'Blair Rd & Ogilvie Rd', fr: 'Ch. Blair et Ch. Ogilvie', aoda: true},
        {en: 'Blair Rd & Meadowbrook Rd', fr: 'Ch. Blair et Ch. Meadowbrook', aoda: false},
        {
            en: 'Blair Rd & Hwy 174 W/B Ramp /Gloucester Centre',
            fr: 'Ch. Blair et Bretelle De La Route 174 En Dir. O. / Centre Gloucester',
            aoda: false,
        },
        {
            en: 'Blohm Dr & Robert Bateman School/ 68M W Of Briston Priv.',
            fr: 'Prom. Blohm et École Robert Bateman / 68 M Ouest Du Privé Briston',
            aoda: false,
        },
        {en: 'Bolton St & Dalhousie St', fr: 'Rue Bolton et Rue Dalhousie', aoda: false},
        {en: 'Booth St & Somerset St W', fr: 'Rue Booth et Rue Somerset O.', aoda: false},
        {en: 'Booth St & Gladstone Ave', fr: 'Rue Booth et Av. Gladstone', aoda: false},
        {en: 'Booth St & Carling Ave', fr: 'Rue Booth et Av. Carling', aoda: false},
        {en: 'Booth St & Raymond St', fr: 'Rue Booth et Rue Raymond', aoda: false},
        {en: 'Booth St & Norman St', fr: 'Rue Booth et Rue Norman', aoda: true},
        {
            en: 'Booth St & War Museum Access / 225 N Of Vimy Place',
            fr: 'Rue Booth et Accès Au Musée De La Guerre / 225 M Nord De La Place Vimy',
            aoda: false,
        },
        {
            en: 'Booth St & Wellington St / Sir John A. Macdonlad Pkwy',
            fr: 'Rue Booth et Rue Wellington / Prom. Sir-John-A.-Macdonlad',
            aoda: false,
        },
        {en: 'Booth St & Eccles St', fr: 'Rue Booth et Rue Eccles', aoda: false},
        {en: 'Booth St & Primrose Ave', fr: 'Rue Booth et Av. Primrose', aoda: false},
        {en: 'Booth St & Willow St', fr: 'Rue Booth et Rue Willow', aoda: false},
        {en: 'Boteler St & Sussex Dr', fr: 'Rue Boteler et Prom. Sussex', aoda: false},
        {en: 'Botsford St/Dauphin Rd & Smyth Rd', fr: 'Rue Botsford / Ch. Dauphin et Ch. Smyth', aoda: false},
        {en: 'Bottriell Way & Charlemagne Blvd N', fr: 'Voie Bottriell et Boul. Charlemagne N.', aoda: true},
        {en: 'Bourassa St & St Laurent Blvd', fr: 'Rue Bourassa et Boul. St-Laurent', aoda: true},
        {en: 'Brant St & Mcarthur Ave', fr: 'Rue Brant et Av. Mcarthur', aoda: false},
        {en: 'Brewer Rd & Bronson Ave', fr: 'Ch. Brewer et Av. Bronson', aoda: false},
        {en: 'Brian Coburn Blvd & Page (Mup)', fr: 'Boul. Brian Coburn et Ch. Pagé (Sentier Polyvalent)', aoda: true},
        {en: 'Brian Coburn Blvd & Tenth Line Rd', fr: 'Boul. Brian Coburn et Ch. Tenth Line', aoda: false},
        {
            en: 'Briar Hill Dr/Sandalwood & Heron Rd',
            fr: 'Prom. Briar Hill / Prom. Sandalwood et Ch. Heron',
            aoda: true,
        },
        {en: 'Bridge St & Dickinson', fr: 'Rue Bridge et Dickinson', aoda: false},
        {
            en: 'Bridge St & Long Island Rd / Van Vliet Rd',
            fr: 'Rue Bridge et Ch. Long Island / Ch. Van Vliet',
            aoda: false,
        },
        {
            en: 'Bridle Path Dr/Daze Dr & Hunt Club Rd',
            fr: 'Prom. Bridle Path / Prom. Daze et Ch. Hunt Club',
            aoda: false,
        },
        {en: 'Bridlepark & Stonehaven', fr: 'Bridlepark et Stonehaven', aoda: false},
        {en: 'Brittany Dr & Montreal Rd', fr: 'Prom. Brittany et Ch. De Montréal', aoda: false},
        {
            en: 'Brittany Dr/Dunbarton Crt & St Laurent Blvd',
            fr: 'Prom. Brittany / Cour Dunbarton et Boul. St-Laurent',
            aoda: false,
        },
        {en: 'Broad St & Sir John A Macdonald Pkwy', fr: 'Rue Broad et Prom. Sir- John-A.-Macdonald', aoda: true},
        {en: 'Broadview Ave & Carling Ave', fr: 'Av. Broadview et Av. Carling', aoda: false},
        {en: 'Bronson & 288M N Of Sunnyside', fr: 'Bronson et 288 M Nord De Sunnyside', aoda: false},
        {en: 'Bronson Ave & Heron Rd', fr: 'Av. Bronson et Ch. Heron', aoda: false},
        {en: 'Bronson Ave & Powell Ave', fr: 'Av. Bronson et Av. Powell', aoda: false},
        {en: 'Bronson Ave & Gladstone Ave', fr: 'Av. Bronson et Av. Gladstone', aoda: false},
        {en: 'Bronson Ave & Carling Ave /Glebe Ave', fr: 'Av. Bronson et Av. Carling / Av. Glebe', aoda: false},
        {en: 'Bronson Ave & Christie St', fr: 'Av. Bronson et Rue Christie', aoda: false},
        {en: 'Bronson Ave & Primrose Ave', fr: 'Av. Bronson et Av. Primrose', aoda: false},
        {en: 'Bronson Ave & Fifth Ave/Madawaska Blvd', fr: 'Av. Bronson et Av. Fifth / Boul. Madawaska', aoda: false},
        {
            en: 'Bronson Ave & Sunnyside Ave Carleton U Ent',
            fr: 'Av. Bronson et Av. Sunnyside / Entrée De L\'Université Carleton',
            aoda: false,
        },
        {
            en: 'Bronson Ave & Catherine St /Raymond St.',
            fr: 'Av. Bronson et Rue Catherine / Rue Raymond.',
            aoda: false,
        },
        {en: 'Bronson Ave & Somerset St W', fr: 'Av. Bronson et Rue Somerset O.', aoda: false},
        {
            en: 'Bronson Ave & Commissioner St / Slater St',
            fr: 'Av. Bronson et Rue Commissioner / Rue Slater',
            aoda: false,
        },
        {en: 'Bronson Ave & Gloucester St', fr: 'Av. Bronson et Rue Gloucester', aoda: false},
        {en: 'Bronson Ave & Laurier Ave W', fr: 'Av. Bronson et Av. Laurier O.', aoda: true},
        {
            en: 'Brookfield Rd & Public Works Canada / 20M W Of Hobson Rd',
            fr: 'Ch. Brookfield et Travaux Publics Canada / 20 M Ouest Du Ch. Hobson',
            aoda: false,
        },
        {
            en: 'Brookfield Rd / Hog\'S Back Rd & Riverside Dr',
            fr: 'Ch. Brookfield / Ch. Hog\'S Back et Prom. Riverside',
            aoda: false,
        },
        {en: 'Bruyere St & Sussex Dr', fr: 'Rue Bruyère et Prom. Sussex', aoda: false},
        {en: 'Burnside Ave & Parkdale Ave', fr: 'Av. Burnside et Av. Parkdale', aoda: false},
        {en: 'Burris Lane & Merivale Rd', fr: 'Ruelle Burris et Ch. Merivale', aoda: false},
        {en: 'Byron Ave & Kirkwood Ave', fr: 'Av. Byron et Av. Kirkwood', aoda: false},
        {en: 'Byron Ave & Island Park Dr', fr: 'Av. Byron et Prom. Island Park', aoda: false},
        {en: 'Byron Ave & Churchill Ave N', fr: 'Av. Byron et Av. Churchill N.', aoda: false},
        {en: 'Byron Ave & Roosevelt Ave', fr: 'Av. Byron et Av. Roosevelt', aoda: false},
        {en: 'Cadence Dr / Cope Dr & Eagleson Rd', fr: 'Prom. Cadence / Prom. Cope et Ch. Eagleson', aoda: false},
        {en: 'Caldwell Ave & Merivale Rd', fr: 'Av. Caldwell et Ch. Merivale', aoda: true},
        {en: 'Campeau Dr & Colchester Sq / Teron Rd', fr: 'Prom. Campeau et Car. Colchester / Ch. Teron', aoda: false},
        {en: 'Campeau Dr & Terry Fox Dr', fr: 'Prom. Campeau et Prom. Terry Fox', aoda: true},
        {en: 'Campeau Dr & Kanata Ave', fr: 'Prom. Campeau et Av. Kanata', aoda: true},
        {
            en: 'Campeau Dr & Herlihey Way / Signature Centre',
            fr: 'Prom. Campeau et Voie Herlihey / Signature Centre',
            aoda: true,
        },
        {en: 'Campeau Dr & Knudson Dr', fr: 'Prom. Campeau et Prom. Knudson', aoda: false},
        {
            en: 'Campeau Dr & 320M W Of Huntmar Rd / Tanger Outlets',
            fr: 'Prom. Campeau et 320 M Ouest Du Ch. Huntmar / Tanger Outlets',
            aoda: false,
        },
        {en: 'Canaan Rd & Hwy 174', fr: 'Ch. Canaan et Autoroute 174', aoda: false},
        {en: 'Canyon Walk & Earl Armstrong Rd', fr: 'Prom. Canyon Walk et Ch. Earl Armstrong', aoda: false},
        {en: 'Capilano Dr & Merivale Rd', fr: 'Prom. Capilano et Ch. Merivale', aoda: false},
        {en: 'Carbrooke St/Irwin Gt & Hazeldean Rd', fr: 'Rue Carbrooke / Porte Irwin et Ch. Hazeldean', aoda: false},
        {en: 'Carleton Ave & Scott St', fr: 'Av. Carleton et Rue Scott', aoda: false},
        {en: 'Carling Ave & 130M W Of Preston', fr: 'Av. Carling et 130 M Ouest De La Rue Preston', aoda: false},
        {en: 'Carling Ave & Parkdale Ave', fr: 'Av. Carling et Av. Parkdale', aoda: false},
        {en: 'Carling Ave & Clyde Ave / Cole Ave', fr: 'Av. Carling et Av. Clyde / Av. Cole', aoda: false},
        {en: 'Carling Ave & Sherwood Dr', fr: 'Av. Carling et Prom. Sherwood', aoda: false},
        {
            en: 'Carling Ave & Maitland Ave / Sherbourne Rd',
            fr: 'Av. Carling et Av. Maitland / Ch. Sherbourne',
            aoda: false,
        },
        {en: 'Carling Ave & Preston St', fr: 'Av. Carling et Rue Preston', aoda: false},
        {
            en: 'Carling Ave & Connaught Ave / Lincoln Heights Galleria',
            fr: 'Av. Carling et Av. Connaught / C. C. Lincoln Heights',
            aoda: false,
        },
        {en: 'Carling Ave & Churchill Ave N', fr: 'Av. Carling et Av. Churchill N.', aoda: false},
        {en: 'Carling Ave & Woodroffe Ave S', fr: 'Av. Carling et Av. Woodroffe S.', aoda: false},
        {
            en: 'Carling Ave & Greenview Ave / Pinecrest Rd',
            fr: 'Av. Carling et Av. Greenview / Ch. Pinecrest',
            aoda: false,
        },
        {en: 'Carling Ave & Richmond Rd', fr: 'Av. Carling et Ch. Richmond', aoda: false},
        {
            en: 'Carling Ave & Civic Hospital / 205M E Of Parkdal Eave.',
            fr: 'Av. Carling et Hôpital D\'Ottawa, Campus Civicl / 205 M Est De L\'Av. Parkdale',
            aoda: true,
        },
        {en: 'Carling Ave & Irving Ave', fr: 'Av. Carling et Av. Irving', aoda: false},
        {en: 'Carling Ave & Merivale Rd', fr: 'Av. Carling et Ch. Merivale', aoda: false},
        {
            en: 'Carling Ave & Westgate Sc E Ent / 110M W Of Merivale Rd.',
            fr: 'Av. Carling et Entrée E. C. C. Westgate / 110 M Ouest Du Ch. Merivale.',
            aoda: false,
        },
        {en: 'Carling Ave & Iroquois Rd', fr: 'Av. Carling et Ch. Iroquois', aoda: false},
        {
            en: 'Carling Ave & Fairlawn Ave \ Woodroffe Ave N.',
            fr: 'Av. Carling et Av. Fairlawn \ Av. Woodroffe N.',
            aoda: false,
        },
        {en: 'Carling Ave & Scrivens St', fr: 'Av. Carling et Rue Scrivens', aoda: false},
        {en: 'Carling Ave & Champagne Ave S', fr: 'Av. Carling et Av. Champagne S.', aoda: false},
        {en: 'Carling Ave & Edgeworth Ave', fr: 'Av. Carling et Av. Edgeworth', aoda: true},
        {en: 'Carling Ave & Kirkwood Ave S', fr: 'Av. Carling et Av. Kirkwood S.', aoda: false},
        {en: 'Carling Ave & Grenon Ave/ Ritchie St.', fr: 'Av. Carling et Av. Grenon/ Rue Ritchie', aoda: false},
        {en: 'Carling Ave & Croydon Ave', fr: 'Av. Carling et Av. Croydon', aoda: false},
        {
            en: 'Carling Ave & Carlingwood Sc/ 195M W Of Iroquois Rd',
            fr: 'Av. Carling et C. C. Carlingwood / 195 M Ouest Du Ch. Iroquois',
            aoda: false,
        },
        {en: 'Carling Ave & Herzberg Rd', fr: 'Av. Carling et Ch. Herzberg', aoda: false},
        {
            en: 'Carling Ave & Lincoln Fields Transit Stn/ 150M W Of Edgeworth Ave',
            fr: 'Av. Carling et Station Lincoln Fields / 150 M Ouest De L\'Av. Edgeworth',
            aoda: false,
        },
        {en: 'Carling Ave & Saigon Crt', fr: 'Av. Carling et Cour Saigon', aoda: false},
        {
            en: 'Carling Ave & Westgate Sc W Ent / 67M E Of Archibald St',
            fr: 'Av. Carling et Entrée O. Du C.C. Westgate / 67 M Est De La Rue Archibald',
            aoda: false,
        },
        {en: 'Carling Ave & Corkstown Rd', fr: 'Av. Carling et Ch. Corkstown', aoda: false},
        {
            en: 'Carling Ave & Kempster Ave/Famous Players',
            fr: 'Av. Carling et Av. Kempster / Cinéma Famous Players',
            aoda: false,
        },
        {en: 'Carling Ave & Viscount Ave', fr: 'Av. Carling et Av. Viscount', aoda: true},
        {
            en: 'Carling Ave & Ncc Bike Path 525M E Of Holly Acres',
            fr: 'Av. Carling Etsentier Pour Vélo De La Ccn 525 M Est De Holly Acres',
            aoda: false,
        },
        {en: 'Carp Rd & Hazeldean Rd', fr: 'Ch. Carp et Ch. Hazeldean', aoda: false},
        {en: 'Carp Rd & Stittsville Main St', fr: 'Ch. Carp et Rue Stittsville Main', aoda: false},
        {en: 'Carp Rd & Hobin St/Mccooeye Ln', fr: 'Ch. Carp et Rue Hobin / Ruelle Mccooeye', aoda: false},
        {
            en: 'Carp Rd & Hwy 417 W/B Off Ramp',
            fr: 'Ch. Carp et Bretelle De Sortie Autoroute 417 Dir. O.',
            aoda: false,
        },
        {en: 'Carp Rd & Kittiwake Dr / Echowoods', fr: 'Ch. Carp et Prom. Kittiwake / Echowoods', aoda: false},
        {en: 'Carriere St & Orleans Blvd', fr: 'Rue Carrière et Boul. Orléans', aoda: false},
        {en: 'Carruthers Ave & Scott St', fr: 'Av. Carruthers et Rue Scott', aoda: false},
        {en: 'Carruthers Ave & Wellington St', fr: 'Av. Carruthers et Rue Wellington', aoda: false},
        {en: 'Carson Ave/Codds Rd & Montreal Rd', fr: 'Av. Carson/Ch. Codds et Ch. De Montréal', aoda: false},
        {en: 'Castlefrank Rd & Hazeldean Rd', fr: 'Ch. Castlefrank et Ch. Hazeldean', aoda: false},
        {en: 'Castlefrank Rd & Katimavik Rd', fr: 'Ch. Castlefrank et Ch. Katimavik', aoda: false},
        {
            en: 'Castlefrank Rd & Hwy 417 Wb Off Ramp',
            fr: 'Ch. Castlefrank et Bretelle De Sortie Autoroute 417 Dir. O.',
            aoda: false,
        },
        {
            en: 'Castlefrank Rd & Hwy 417 Eb On Ramp',
            fr: 'Ch. Castlefrank et Bretelle D\'Accès Autoroute 417 Dir. E.',
            aoda: false,
        },
        {en: 'Castlefrank Rd & Mccurdy / Tamblyn', fr: 'Ch. Castlefrank et Mccurdy / Tamblyn', aoda: false},
        {en: 'Castlefrank Rd & Kakulu Dr', fr: 'Ch. Castlefrank et Prom. Kakulu', aoda: false},
        {
            en: 'Castlefrank Rd / Abbott St & Terry Fox Dr',
            fr: 'Ch. Castlefrank / Rue Abbott et Prom. Terry Fox',
            aoda: true,
        },
        {
            en: 'Catherine St & O\'Connor St /Hwy 417 Wb On Ramp',
            fr: 'Rue Catherine et Rue O\'Connor / Bretelle D\'Accès Autoroute 417 Dir. O.',
            aoda: true,
        },
        {en: 'Catherine St & Kent St', fr: 'Rue Catherine et Rue Kent', aoda: false},
        {en: 'Catherine St & Percy St', fr: 'Rue Catherine et Rue Percy', aoda: false},
        {
            en: 'Cedarview Rd & Barrhaven Middle School/235M S Of Fallowfield',
            fr: 'Ch. Cedarview et École Secondaire Barrhaven /235 M Sud Du Ch. Fallowfield',
            aoda: false,
        },
        {en: 'Cedarview Rd / Tartan & Strandherd Dr', fr: 'Ch. Cedarview / Tartan et Prom. Strandherd', aoda: false},
        {en: 'Cedarwood Dr & Walkley Rd', fr: 'Prom. Cedarwood et Ch. Walkley', aoda: false},
        {en: 'Central Park Dr N & Merivale Rd', fr: 'Prom. Central Park N. et Ch. Merivale', aoda: true},
        {en: 'Central Park Dr S & Merivale Rd', fr: 'Prom. Central Park S. et Ch. Merivale', aoda: true},
        {en: 'Centrepointe Dr & Tallwood Dr', fr: 'Prom. Centrepointe et Prom. Tallwood', aoda: false},
        {
            en: 'Centrepointe Dr & Rec Path Ben Franklin Place/125M S Of Constellation',
            fr: 'Prom. Centrepointe et Sentier Récréatif De La Place-Ben-Franklin /125 M Sud De Constellation',
            aoda: false,
        },
        {
            en: 'Centrepointe Dr & Pedestrian Signal / 90M N Of Chrysalis Way',
            fr: 'Prom. Centrepointe et Feu Pour Piétons / 90 M Nord De La Voie Chrysalis',
            aoda: false,
        },
        {
            en: 'Centrepointe Dr W & Recreation Pathway / 50M S Of Marble Arch',
            fr: 'Prom. Centrepointe O. et Sentier Récréatif / 50 M Sud De Marble Arch',
            aoda: false,
        },
        {
            en: 'Centrum Blvd/Place D\'Orleans Sc E Ent & Place D\'Orleans Dr E',
            fr: 'Boul. Centrum / Entrée E. C. C. Place D\'Orléans et Prom. Place D\'Orléans E.',
            aoda: false,
        },
        {en: 'Chamberlain Ave & Kent St', fr: 'Av. Chamberlain et Rue Kent', aoda: false},
        {en: 'Chamberlain Ave & Percy St', fr: 'Av. Chamberlain et Rue Percy', aoda: false},
        {
            en: 'Champlain St & Highway 174 Wb Off Ramp',
            fr: 'Rue Champlain et Bretelle De Sortie Autoroute 174 Dir. O.',
            aoda: false,
        },
        {en: 'Champlain St & Jeanne D\'Arc Blvd', fr: 'Rue Champlain et Boul. Jeanne-D\'Arc', aoda: false},
        {
            en: 'Champlain St /Place D\'Orleans Sc & Place D\'Orleans Dr W',
            fr: 'Rue Champlain / C. C. Place D\'Orléans et Prom. Place D\'Orléans O.',
            aoda: false,
        },
        {en: 'Chapel St & Rideau St', fr: 'Rue Chapel et Rue Rideau', aoda: false},
        {
            en: 'Chapman Mills Dr & Leamington Way / Mancini Way',
            fr: 'Prom. Chapman Mills et Voie Leamington / Voie Mancini',
            aoda: true,
        },
        {en: 'Chapman Mills Dr & Clearbrook Dr', fr: 'Prom. Chapman Mills et Prom. Clearbrook', aoda: false},
        {en: 'Chapman Mills Dr & Woodroffe Ave', fr: 'Prom. Chapman Mills et Av. Woodroffe', aoda: false},
        {
            en: 'Charlemagne Blvd & Princess Louise Dr / Valade Cr',
            fr: 'Boul. Charlemagne et Prom. Princess Louise / Crois. Valade',
            aoda: false,
        },
        {
            en: 'Charlemagne Blvd / Des Epinettes Ave & Tenth Line Rd',
            fr: 'Boul. Charlemagne / Av. Des Épinettes et Ch. Tenth Line',
            aoda: false,
        },
        {en: 'Charlotte St & Rideau St', fr: 'Rue Charlotte et Rue Rideau', aoda: false},
        {en: 'Chesterton Dr & Meadowlands Dr', fr: 'Prom. Chesterton et Prom. Meadowlands', aoda: false},
        {en: 'Chimo Dr/Hearst Way & Katimavik Rd', fr: 'Prom. Chimo / Voie Hearst et Ch. Katimavik', aoda: false},
        {en: 'Churchill Ave & Richmond Rd', fr: 'Av. Churchill et Ch. Richmond', aoda: true},
        {en: 'Churchill Ave & Dovercourt Ave', fr: 'Av. Churchill et Av Dovercourt', aoda: false},
        {en: 'Churchill Ave & Clare / Princeton', fr: 'Av. Churchill et Rue Clare / Princeton', aoda: false},
        {en: 'Clare St & Kirkwood Ave', fr: 'Rue Clare et Av. Kirkwood', aoda: false},
        {en: 'Clarendon Ave & Wellington St', fr: 'Av. Clarendon et Rue Wellington', aoda: false},
        {en: 'Claridge Dr & Strandherd Rd', fr: 'Prom. Claridge et Prom. Strandherd', aoda: false},
        {en: 'Claridge/Stoneway & Woodroffe Ave', fr: 'Claridge / Stoneway et Av. Woodroffe', aoda: false},
        {en: 'Claymor Ave & Dynes Rd', fr: 'Av. Claymor et Ch. Dynes', aoda: true},
        {en: 'Cleary Ave & Richmond Rd', fr: 'Av. Cleary et Ch. Richmond', aoda: false},
        {en: 'Clegg St & Main St', fr: 'Rue Clegg et Rue Main', aoda: true},
        {en: 'Clegg St & Colonel By Dr', fr: 'Rue Clegg et Prom. Du Colonel-By', aoda: false},
        {en: 'Clementine Blvd & Heron Rd', fr: 'Boul. Clementine et Ch. Heron', aoda: false},
        {en: 'Cleroux Cres & Innes Rd', fr: 'Crois. Cleroux et Ch. Innes', aoda: false},
        {en: 'Clyde Ave & Doheny St', fr: 'Av. Clyde et Rue Doheny', aoda: false},
        {
            en: 'Clyde Ave /Merivale & Merivale Rd / Lotta Ave',
            fr: 'Av. Clyde / Merivale et Ch. Merivale / Av. Lotta',
            aoda: false,
        },
        {en: 'Cobourg St & Rideau St', fr: 'Rue Cobourg et Rue Rideau', aoda: false},
        {en: 'Cobourg St & St Patrick St', fr: 'Rue Cobourg et Rue St-Patrick', aoda: false},
        {en: 'Coldrey Ave & Kirkwood Ave', fr: 'Av. Coldrey et Av. Kirkwood', aoda: false},
        {en: 'Coldrey Ave/Crerar Ave & Merivale Rd', fr: 'Av. Coldrey/Crerar Ave et Ch. Merivale', aoda: false},
        {
            en: 'Colonel By Dr & Campus Stn U Of Ottawa / 650M S Of Dnd Entrance',
            fr: 'Prom. Du Colonel-By et Station Campus De L\'Université D\'Ottawa / 650 M Sud De L\'Entrée Du Mdn',
            aoda: true,
        },
        {
            en: 'Colonel By Dr & Hawthorne Ave /Pretoria Bridge',
            fr: 'Prom. Du Colonel-By et Av. Hawthorne / Pont Pretoria',
            aoda: false,
        },
        {en: 'Colonel By Dr & Hog\'S Back Rd', fr: 'Prom. Du Colonel-By et Ch. Hog\'S Back', aoda: false},
        {en: 'Colonel By Dr & Daly Ave', fr: 'Prom. Du Colonel-By et Av. Daly', aoda: false},
        {
            en: 'Colonel By Dr & Carleton University/ 1150M N Of Hogs Back Rd',
            fr: 'Prom. Du Colonel-By et Université Carleton / 1150 M Nord Du Ch. Of Hog\'S Back',
            aoda: false,
        },
        {
            en: 'Colonel By Dr /Sussex Dr & Rideau St',
            fr: 'Prom. Du Colonel-By /Prom. Sussex et Rue Rideau',
            aoda: true,
        },
        {en: 'Colonnade Rd & Merivale Rd', fr: 'Ch. Colonnade et Ch. Merivale', aoda: false},
        {en: 'Colonnade Rd & Prince Of Wales Dr', fr: 'Ch. Colonnade et Prom. Prince Of Wales', aoda: false},
        {en: 'Colonnade Rd & Colonnade Rd West', fr: 'Ch. Colonnade et Ch. Colonnade Ouest', aoda: false},
        {en: 'Colonnade Rd & Colonnade Rd East', fr: 'Ch. Colonnade et Ch. Colonnade Est', aoda: false},
        {en: 'Colonnade Rd & Citiplace Dr', fr: 'Ch. Colonnade et Prom. Citiplace', aoda: false},
        {en: 'Conroy Rd & Walkley Rd', fr: 'Ch. Conroy et Ch. Walkley', aoda: false},
        {en: 'Conroy Rd & St Laurent Blvd', fr: 'Ch. Conroy et Boul. St-Laurent', aoda: false},
        {
            en: 'Conroy Rd & Recreation Path / 210M N Of Hunt Club Rd',
            fr: 'Ch. Conroy et Sentier Récréatif / 210 M Nord Du Ch. Hunt Club',
            aoda: false,
        },
        {en: 'Conroy Rd & Lorry Greenberg Dr', fr: 'Ch. Conroy et Prom. Lorry Greenberg', aoda: false},
        {en: 'Conroy Rd & Johnston Rd', fr: 'Ch. Conroy et Ch. Johnston', aoda: false},
        {en: 'Cope Dr & Terry Fox Dr', fr: 'Prom. Cope et Prom. Terry Fox', aoda: false},
        {en: 'Cote St & St Laurent Blvd', fr: 'Rue Côté et Boul. St-Laurent', aoda: false},
        {en: 'Coventry Rd & St Laurent Blvd', fr: 'Ch. Coventry et Boul. St-Laurent', aoda: true},
        {en: 'Coventry Rd & Lola St', fr: 'Ch. Coventry et Rue Lola', aoda: false},
        {
            en: 'Coventry Rd & St Laurent Sc W Ent/ 250M W Of St. Laurent',
            fr: 'Ch. Coventry et Entrée O. Du C. C. St-Laurent / 250 M Ouest Du Boul. St. Laurent',
            aoda: false,
        },
        {
            en: 'Coventry Rd & St Laurent Sc N Ent / 230M W Of St Laurent',
            fr: 'Ch. Coventry et Entrée N. Du C. C. St-Laurent / 230 M Ouest Du Boul. St Laurent',
            aoda: true,
        },
        {
            en: 'Coventry Rd & Aaa Stadium W Access/ 190M E Of Vanier Parkway',
            fr: 'Ch. Coventry et Accès O. Du Stade Aaa / 190 M Est De La Prom. Vanier',
            aoda: false,
        },
        {
            en: 'Coventry Rd /Rcmp Access & Vanier Pkwy',
            fr: 'Ch. Coventry /Accès À La Grc et Prom. Vanier',
            aoda: false,
        },
        {en: 'Craig Henry Dr & Knoxdale Rd', fr: 'Prom. Craig Henry et Ch. Knoxdale', aoda: false},
        {en: 'Cresthaven Dr & Strandherd Dr', fr: 'Prom. Cresthaven et Prom. Strandherd', aoda: false},
        {en: 'Crestway Dr & Strandherd Dr', fr: 'Prom. Crestway et Prom. Strandherd', aoda: false},
        {en: 'Crestway Dr & Prince Of Wales Dr', fr: 'Prom. Crestway et Prom. Prince Of Wales', aoda: true},
        {
            en: 'Crosskeys Pl / Helene-Campbell Rd & Strandherd Dr',
            fr: 'Place Crosskeys / Ch. Hélène-Campbell et Prom. Strandherd',
            aoda: true,
        },
        {en: 'Croydon Ave & Richmond Rd', fr: 'Av. Croydon et Ch. Richmond', aoda: true},
        {en: 'Cumberland St & Laurier Ave E', fr: 'Rue Cumberland et Av. Laurier E.', aoda: false},
        {en: 'Cumberland St & St Patrick St', fr: 'Rue Cumberland et Rue St-Patrick', aoda: false},
        {en: 'Cumberland St & George St', fr: 'Rue Cumberland et Rue George', aoda: false},
        {en: 'Cumberland St & Murray St', fr: 'Rue Cumberland et Rue Murray', aoda: false},
        {en: 'Cumberland St & Rideau St', fr: 'Rue Cumberland et Rue Rideau', aoda: false},
        {en: 'Cummings Ave & Donald St', fr: 'Av. Cummings et Rue Donald', aoda: false},
        {en: 'Cummings Ave/Labelle St & Cyrville Rd', fr: 'Av. Cummings / Rue Labelle et Ch. Cyrville', aoda: false},
        {en: 'Cummings St & Montreal Rd', fr: 'Av. Cummings et Ch. De Montréal', aoda: false},
        {en: 'Cyrville Rd & Ogilvie Rd', fr: 'Ch. Cyrville et Ch. Ogilvie', aoda: true},
        {en: 'Cyrville Rd & Innes Rd', fr: 'Ch. Cyrville et Ch. Innes', aoda: false},
        {en: 'Cyrville Rd & Star Top Rd', fr: 'Ch. Cyrville et Ch. Star Top', aoda: true},
        {en: 'Cyrville Rd & Meadowbrook Rd', fr: 'Ch. Cyrville et Ch. Meadowbrook', aoda: false},
        {en: 'Dalhousie St & Rideau St', fr: 'Rue Dalhousie et Rue Rideau', aoda: false},
        {en: 'Dalhousie St & St Patrick St', fr: 'Rue Dalhousie et Rue St-Patrick', aoda: false},
        {en: 'Dalhousie St & George St', fr: 'Rue Dalhousie et Rue George', aoda: false},
        {en: 'Dalhousie St & York St', fr: 'Rue Dalhousie et Rue York', aoda: false},
        {en: 'Dalhousie St & Murray St', fr: 'Rue Dalhousie et Rue Murray', aoda: false},
        {en: 'Daly Ave & Nicholas St', fr: 'Av. Daly et Rue Nicholas', aoda: true},
        {en: 'Data Centre Rd & Riverside Dr', fr: 'Ch. Data Centre et Prom. Riverside', aoda: false},
        {en: 'Deakin St & Prince Of Wales Dr', fr: 'Rue Deakin et Prom. Prince Of Wales', aoda: true},
        {en: 'Debra Ave & Meadowlands Dr', fr: 'Av. Debra et Prom. Meadowlands', aoda: false},
        {en: 'Deer Park Rd & Meadowlands Dr', fr: 'Ch. Deer Park et Prom. Meadowlands', aoda: false},
        {en: 'Deer Park Rd / Dynes Rd & Fisher Ave', fr: 'Ch. Deer Park / Ch. Dynes et Av. Fisher', aoda: true},
        {
            en: 'Deerfox Dr/Stoneway Dr & Woodroffe Ave',
            fr: 'Prom. Deerfox/ Prom. Stoneway et Av. Woodroffe',
            aoda: false,
        },
        {en: 'Den Haag Dr & 160M E Of Carsons', fr: 'Prom. Den Haag et 160 M Est De Carsons', aoda: false},
        {
            en: 'Den Haag Dr/Lang\'S Rd & Montreal Rd',
            fr: 'Prom. Den Haag / Ch. Lang\'S et Ch. De Montréal',
            aoda: false,
        },
        {en: 'Des Epinettes Ave & Jeanne D\'Arc Blvd', fr: 'Av. Des Épinettes et Boul. Jeanne-D\'Arc', aoda: false},
        {en: 'Deschamps Ave & Vanier Pkwy', fr: 'Av. Deschamps et Prom. Vanier', aoda: false},
        {en: 'Donald St & Lola St', fr: 'Rue Donald et Rue Lola', aoda: false},
        {en: 'Donald St & St Laurent Blvd', fr: 'Rue Donald et Boul. St-Laurent', aoda: true},
        {
            en: 'Donald St & Donald Plaza / 110M E Of St Laurent Blvd',
            fr: 'Rue Donald et Donald Plaza / 110 M Est Du Boul. St-Laurent',
            aoda: false,
        },
        {en: 'Donald St & Vanier Pkwy', fr: 'Rue Donald et Prom. Vanier', aoda: false},
        {
            en: 'Donald St & St Paul Ecole/48M E Of Paul Emile Lamarche',
            fr: 'Rue Donald et École St-Paul / 48 M Est De Paul-Émile-Lamarche',
            aoda: true,
        },
        {en: 'Donald St & Quill St', fr: 'Rue Donald et Rue Quill', aoda: false},
        {en: 'Donald St & Telford Ave', fr: 'Rue Donald et Av. Telford', aoda: false},
        {
            en: 'Downpatrick Rd / Mccarthy Rd & Hunt Club Rd',
            fr: 'Ch. Downpatrick / Ch. Maccarthy et Ch. Hunt Club',
            aoda: false,
        },
        {en: 'Dozois Rd/Limebank Rd & Mitch Owens Rd', fr: 'Ch. Dozois/Ch. Limebank et Ch. Mitch Owens', aoda: false},
        {en: 'Dumaurier Ave & Pinecrest Rd', fr: 'Av. Dumaurier et Ch. Pinecrest', aoda: true},
        {en: 'Dumaurier Ave & Richmond Rd', fr: 'Av. Dumaurier et Ch. Richmond', aoda: false},
        {en: 'Dunrobin Rd & Thomas A Dolan Parkway', fr: 'Ch. Dunrobin et Prom. Thomas-A.-Dolan', aoda: false},
        {en: 'Dynes Rd & Prince Of Wales Dr', fr: 'Ch. Dynes et Prom. Prince Of Wales', aoda: true},
        {en: 'Eagleson Rd & Katimavik Rd/ Timm Dr', fr: 'Ch. Eagleson et Ch. Katimavik/ Prom. Timm', aoda: false},
        {
            en: 'Eagleson Rd & Michael Cowpland Dr/ Stonehaven Dr',
            fr: 'Ch. Eagleson et Prom. Michael Cowpland/ Prom. Stonehaven',
            aoda: false,
        },
        {
            en: 'Eagleson Rd & Palomino Dr/Rothesay Dr',
            fr: 'Ch. Eagleson et Prom. Palomino / Prom. Rothesay',
            aoda: false,
        },
        {
            en: 'Eagleson Rd & Hwy 417 E/B On/Off Ramps/ Park N Ride Lot',
            fr: 'Ch. Eagleson et Bretelles D\'Accès et De Sortie Autoroute 417 Dir. E./ Parc-O-Bus',
            aoda: false,
        },
        {
            en: 'Eagleson Rd & Hope Side Rd /Terry Fox Dr',
            fr: 'Ch. Eagleson et Ch. Hope Side / Prom. Terry Fox',
            aoda: false,
        },
        {en: 'Eagleson Rd & Fernbank Rd', fr: 'Ch. Eagleson et Ch. Fernbank', aoda: false},
        {
            en: 'Eagleson Rd & 240M N Of Cadence Dr / Cope Dr',
            fr: 'Ch. Eagleson et 240 M Nord De Prom. Cadence / Prom. Cope',
            aoda: false,
        },
        {en: 'Earl Armstrong Rd & River Rd', fr: 'Ch. Earl Armstrong et Ch. River', aoda: false},
        {en: 'Earl Armstrong Rd & Spratt Rd', fr: 'Ch. Earl Armstrong et Ch. Spratt', aoda: false},
        {en: 'Earl Armstrong Rd & Shoreline Dr', fr: 'Ch. Earl Armstrong et Prom. Shoreline', aoda: false},
        {
            en: 'Earl Armstrong Rd & Park N Ride/295M E Of River Rd',
            fr: 'Ch. Earl Armstrong et Parc-O-Bus / 295 M Est Du Ch. River',
            aoda: false,
        },
        {en: 'Earl Armstrong Rd & Limebank Rd', fr: 'Ch. Earl Armstrong et Ch. Limebank', aoda: false},
        {en: 'Earl Armstrong Rd & 235M E Of Spratt', fr: 'Ch. Earl Armstrong et 235 M Est Du Ch. Spratt', aoda: false},
        {en: 'Earl Grey Dr & Kanata Ave', fr: 'Prom. Earl Grey et Av. Kanata', aoda: false},
        {
            en: 'Earl Grey Dr & Walmart/175 M W Of Kanata Ave',
            fr: 'Prom. Earl Grey et Walmart / 175 M Ouest De L\'Av. Kanata',
            aoda: false,
        },
        {en: 'Earl Mulligan Dr & Woodroffe Ave', fr: 'Prom. Earl Mulligan et Av. Woodroffe', aoda: false},
        {en: 'Eastvale Dr S & Ogilvie Rd', fr: 'Prom. Eastvale S. et Ch. Ogilvie', aoda: true},
        {en: 'Edgar Brault St & St Joseph Blvd', fr: 'Rue Edgar Brault et Boul. St-Joseph', aoda: false},
        {en: 'Edgewater St & Hazeldean Rd', fr: 'Rue Edgewater et Ch. Hazeldean', aoda: false},
        {
            en: 'Edgewater St / Charlie Rogers Pl & Terry Fox Dr',
            fr: 'Rue Edgewater / Place Charlie Rogers et Prom. Terry Fox',
            aoda: false,
        },
        {en: 'Edgeworth Ave/Mcewen Ave & Richmond Rd', fr: 'Av. Edgeworth /Av. Mcewen et Ch. Richmond', aoda: false},
        {en: 'Elgin St (East Rdwy) & Sparks St', fr: 'Rue Elgin (Chaussée Est) et Rue Sparks', aoda: false},
        {en: 'Elgin St & Gladstone Ave', fr: 'Rue Elgin et Av. Gladstone', aoda: false},
        {en: 'Elgin St & Somerset St W', fr: 'Rue Elgin et Rue Somerset O.', aoda: false},
        {en: 'Elgin St & Lisgar St', fr: 'Rue Elgin et Rue Lisgar', aoda: false},
        {en: 'Elgin St & Laurier Ave W', fr: 'Rue Elgin et Av. Laurier O.', aoda: false},
        {
            en: 'Elgin St & Slater St /Mackenzie King Br',
            fr: 'Rue Elgin et Rue Slater / Pont Mackenzie King',
            aoda: false,
        },
        {en: 'Elgin St & Maclaren St', fr: 'Rue Elgin et Rue Maclaren', aoda: false},
        {en: 'Elgin St & Nepean St', fr: 'Rue Elgin et Rue Nepean', aoda: false},
        {en: 'Elgin St & Waverley St', fr: 'Rue Elgin et Rue Waverley', aoda: false},
        {
            en: 'Elgin St /Pretoria Bridge & Queen Elizabeth Drwy',
            fr: 'Rue Elgin /Pont Pretoria et Prom. Reine-Élizabeth',
            aoda: false,
        },
        {en: 'Elgin St (West Rdwy) & Sparks St', fr: 'Rue Elgin (Chaussée Ouest) et Rue Sparks', aoda: false},
        {en: 'Elm St & Preston St', fr: 'Rue Elm et Rue Preston', aoda: false},
        {
            en: 'Elmlea Gate/Shoppers City East & Ogilvie Rd',
            fr: 'Porte Elmlea/Shoppers City East et Ch. Ogilvie',
            aoda: true,
        },
        {en: 'Elmridge Dr/Jasmine Cres & Ogilvie Rd', fr: 'Prom. Elmridge/Crois. Jasmine et Ch. Ogilvie', aoda: false},
        {en: 'Empress Ave & Somerset St W', fr: 'Av. Empress et Rue Somerset O.', aoda: false},
        {en: 'Enterprise Ave & Merivale Rd', fr: 'Av. Enterprise et Ch. Merivale', aoda: false},
        {
            en: 'Erindale Dr / Glenmount Ave & Maitland Ave',
            fr: 'Prom. Erindale / Av. Glenmount et Av. Maitland',
            aoda: false,
        },
        {en: 'Esprit Dr / Orchardview Ave & Innes Rd', fr: 'Prom. Esprit / Av. Orchardview et Ch. Innes', aoda: false},
        {en: 'Evelyn Ave & Main St', fr: 'Av. Evelyn et Rue Main', aoda: true},
        {en: 'Fairmont Ave & Gladstone Ave', fr: 'Av. Fairmont et Av. Gladstone', aoda: false},
        {en: 'Fairmont Ave & Wellington St', fr: 'Av. Fairmont et Rue Wellington', aoda: false},
        {en: 'Falaise Rd & Prince Of Wales Dr', fr: 'Ch. Falaise et Prom. Prince Of Wales', aoda: false},
        {en: 'Fallowfield Rd & Hwy 416 Nb Ramp', fr: 'Ch. Fallowfield et Bretelle Autoroute 416 Dir. N.', aoda: true},
        {en: 'Fallowfield Rd & Greenbank Rd', fr: 'Ch. Fallowfield et Ch. Greenbank', aoda: true},
        {en: 'Fallowfield Rd & Moodie Dr', fr: 'Ch. Fallowfield et Prom. Moodie', aoda: true},
        {en: 'Fallowfield Rd & Woodroffe Ave', fr: 'Ch. Fallowfield et Av. Woodroffe', aoda: true},
        {en: 'Fallowfield Rd & Larkin Dr', fr: 'Ch. Fallowfield et Prom. Larkin', aoda: false},
        {
            en: 'Fallowfield Rd & Barrhaven Crossing Sc Ent/ 720M W Of Park N Ride',
            fr: 'Ch. Fallowfield et Entrée Du C. C. Barrhaven Crossing / 720 M Ouest Du Parc-O-Bus',
            aoda: false,
        },
        {en: 'Fallowfield Rd & Strandherd Dr', fr: 'Ch. Fallowfield et Prom. Strandherd', aoda: true},
        {en: 'Fallowfield Rd & Prince Of Wales Dr', fr: 'Ch. Fallowfield et Prom. Prince Of Wales', aoda: true},
        {
            en: 'Fallowfield Rd & 275M W Of Woodroffe',
            fr: 'Ch. Fallowfield et 275 M Ouest De L\'Av. Woodroffe',
            aoda: false,
        },
        {en: 'Fallowfield Rd & Transitway/Cnr', fr: 'Ch. Fallowfield et Transitway / Cn', aoda: false},
        {en: 'Family Brown Lane & Merivale Rd', fr: 'Rle Family Brown et Ch. Merivale', aoda: false},
        {en: 'Fernbank Rd & Terry Fox Dr', fr: 'Ch. Fernbank et Prom. Terry Fox', aoda: false},
        {en: 'Fernbank Rd & Stittsville Main St', fr: 'Ch. Fernbank et Rue Stittsville Main', aoda: false},
        {en: 'Fernbank Rd & Walmart/Smart Centre', fr: 'Ch. Fernbank et Walmart / Smart Centre', aoda: false},
        {en: 'Fernbank Rd & Robert Grant Ave', fr: 'Ch. Fernbank et Av. Robert Grant', aoda: true},
        {en: 'Fielding Dr & Mccarthy Rd', fr: 'Prom. Fielding et Ch. Maccarthy', aoda: true},
        {en: 'Finn Court & Heron Rd', fr: 'Cour Finn et Ch. Heron', aoda: false},
        {en: 'Fisher Ave & Meadowlands Dr', fr: 'Av. Fisher et Prom. Meadowlands', aoda: false},
        {en: 'Fisher Ave & Prince Of Wales Dr', fr: 'Av. Fisher et Prom. Prince Of Wales', aoda: false},
        {en: 'Fisher Ave & 72M S Of Normandy Cres N', fr: 'Av. Fisher et 72 M Sud Du Crois. Normandy N.', aoda: false},
        {en: 'Fisher Ave & Tunis Ave', fr: 'Av. Fisher et Av. Tunis', aoda: false},
        {en: 'Fisher Ave & Shillington Ave', fr: 'Av. Fisher et Av. Shillington', aoda: false},
        {en: 'Fisher Ave & Trent St', fr: 'Av. Fisher et Rue Trent', aoda: false},
        {
            en: 'Fisher Ave & Pedestrian Signal / 220M S Of Trent St',
            fr: 'Av. Fisher et Feu Pour Piétons / 22 M Sud De La Rue Trent',
            aoda: false,
        },
        {en: 'Fisher Ave & Mccooey Lane', fr: 'Av. Fisher et Rle Mccooey', aoda: false},
        {en: 'Fisher Ave & Kintyre Private', fr: 'Av. Fisher et Privé Kintyre', aoda: false},
        {
            en: 'Flamborough/Innovation Dr & Terry Fox Dr',
            fr: 'Voie Flamborough / Prom. Innovation et Prom. Terry Fox',
            aoda: false,
        },
        {en: 'Forest Valley Dr & Orleans Blvd', fr: 'Prom. Forest Valley et Boul. Orléans', aoda: false},
        {
            en: 'Forest Valley Dr/ Youville Dr & St Joseph Blvd',
            fr: 'Prom. Forest Valley/ Prom. Youville et Boul. St-Joseph',
            aoda: false,
        },
        {
            en: 'Fortune Dr/Vineyard Dr & Jeanne D\'Arc Blvd',
            fr: 'Prom. Fortune / Prom. Vineyard et Boul. Jeanne-D\'Arc',
            aoda: false,
        },
        {en: 'Fourth Line Rd & Roger Stevens Dr', fr: 'Ch. Fourth Line et Prom. Roger Stevens', aoda: false},
        {en: 'Fowler St/ Nixonfarm Dr & Perth St', fr: 'Rue Fowler / Prom. Nixonfarm et Rue Perth', aoda: false},
        {
            en: 'Foxfield Dr/Malvern Dr & Greenbank Rd',
            fr: 'Prom. Foxfield / Prom. Malvern et Ch. Greenbank',
            aoda: true,
        },
        {en: 'Frank Bender St & Jeanne D\'Arc Blvd', fr: 'Rue Frank Bender et Boul. Jeanne-D\'Arc', aoda: false},
        {en: 'Frank Bender St & Innes Rd', fr: 'Rue Frank Bender et Ch. Innes', aoda: false},
        {en: 'Frank Bender St & 210M S Of Innes', fr: 'Rue Frank Bender et 210 M Sud Du Ch. Innes', aoda: false},
        {en: 'Frank Kenny Rd & Trim Rd', fr: 'Ch. Frank Kenny et Ch. Trim', aoda: false},
        {en: 'Fraser Ave & Richmond Rd', fr: 'Av. Fraser et Ch. Richmond', aoda: false},
        {
            en: 'Freiman Mall/150M E Of Sussex & George St',
            fr: 'Mail Freiman / 150 M Est De Prom. Sussex et Rue George',
            aoda: false,
        },
        {
            en: 'Freiman Mall/160M E Of Col By-Sussex & Rideau St',
            fr: 'Mail Freiman / 160 M Est De Prom. Colonel-By, Prom. Sussex et Rue Rideau',
            aoda: false,
        },
        {en: 'Friel St & Rideau St', fr: 'Rue Friel et Rue Rideau', aoda: false},
        {en: 'Fringewood Dr & Hazeldean Rd', fr: 'Prom. Fringewood et Ch. Hazeldean', aoda: false},
        {en: 'Frobisher Lane & Riverside Dr', fr: 'Ruelle Frobisher et Prom. Riverside', aoda: true},
        {
            en: 'Garland St/Somerset St & Wellington St',
            fr: 'Rue Garland / Rue Somerset E. et Rue Wellington',
            aoda: false,
        },
        {en: 'George St & Sussex Dr', fr: 'Rue George et Prom. Sussex', aoda: false},
        {
            en: 'George St & William Mall/ 75M E Of Feiman Mall',
            fr: 'Rue George et Mail William / 75 M Est Du Mail Freiman',
            aoda: true,
        },
        {en: 'George St West & Preston St', fr: 'Rue George O. et Rue Preston', aoda: false},
        {
            en: 'Georgina Dr/Lenester Ave & Woodroffe Ave',
            fr: 'Prom. Georgina / Av. Lenester et Av. Woodroffe',
            aoda: false,
        },
        {en: 'Gilligan Rd & Leitrim Rd', fr: 'Ch. Gilligan et Ch. Leitrim', aoda: false},
        {en: 'Gilmour St & O\'Connor St', fr: 'Rue Gilmour et Rue O\'Connor', aoda: true},
        {en: 'Gilmour St & Kent St', fr: 'Rue Gilmour et Rue Kent', aoda: true},
        {en: 'Gladstone Ave & O\'Connor St', fr: 'Av. Gladstone et Rue O\'Connor', aoda: true},
        {en: 'Gladstone Ave & Rochester St', fr: 'Av. Gladstone et Rue Rochester', aoda: true},
        {en: 'Gladstone Ave & Percy St', fr: 'Av. Gladstone et Rue Percy', aoda: false},
        {en: 'Gladstone Ave & Kent St', fr: 'Av. Gladstone et Rue Kent', aoda: true},
        {en: 'Gladstone Ave & Metcalfe St', fr: 'Av. Gladstone et Rue Metcalfe', aoda: false},
        {en: 'Gladstone Ave & Preston St', fr: 'Av. Gladstone et Rue Preston', aoda: false},
        {en: 'Gladstone Ave & Lyon St N', fr: 'Av. Gladstone et Rue Lyon N.', aoda: true},
        {en: 'Gladstone Ave & Parkdale Ave', fr: 'Av. Gladstone et Av. Parkdale', aoda: false},
        {en: 'Glenhaven Private & Walkley Rd', fr: 'Privé Glenhaven et Ch. Walkley', aoda: false},
        {en: 'Gloucester St & Lyon St N', fr: 'Rue Gloucester et Rue Lyon N.', aoda: false},
        {en: 'Gloucester St & Kent St', fr: 'Rue Gloucester et Rue Kent', aoda: true},
        {en: 'Gloucester St & O\'Connor St', fr: 'Rue Gloucester et Rue O\'Connor', aoda: true},
        {en: 'Golden Ave & Richmond Rd', fr: 'Av. Golden et Ch. Richmond', aoda: false},
        {en: 'Goulbourn Forced Rd & Kanata Ave', fr: 'Ch. Goulbourn Forced et Av. Kanata', aoda: false},
        {en: 'Graham Ave/Lees Ave & Main St', fr: 'Av. Graham / Av. Lees et Rue Main', aoda: true},
        {en: 'Grant Carmen Dr & Meadowlands Dr', fr: 'Prom. Grant Carmen et Prom. Meadowlands', aoda: false},
        {
            en: 'Granville Ave/Lafontaine Ave & Montreal Rd',
            fr: 'Av. Granville / Av. Lafontaine et Ch. De Montréal',
            aoda: false,
        },
        {en: 'Grassy Plains Rd & Stonehaven Dr', fr: 'Ch. Grassy Plains et Prom. Stonehaven', aoda: false},
        {en: 'Greenbank Rd & Dundonald Dr', fr: 'Ch. Greenbank et Prom. Dundonald', aoda: true},
        {en: 'Greenbank Rd & Highbury Park', fr: 'Ch. Greenbank et Prom. Highbury Park', aoda: true},
        {
            en: 'Greenbank Rd & Iris St / Hwy 417 Eb Off Ramp',
            fr: 'Ch. Greenbank et Rue Iris / Bretelle De Sortie Autoroute 417 Dir. E.',
            aoda: false,
        },
        {en: 'Greenbank Rd & Lisa Ave', fr: 'Ch. Greenbank et Av. Lisa', aoda: true},
        {en: 'Greenbank Rd & Larkin Dr', fr: 'Ch. Greenbank et Prom. Larkin', aoda: true},
        {
            en: 'Greenbank Rd & Greenbank Square Sc Ent/ 250M N Of West Hunt Club',
            fr: 'Ch. Greenbank et Entrée C. C. Greenbank Square / 250 M Nord Du Ch. West Hunt Club',
            aoda: false,
        },
        {en: 'Greenbank Rd & Strandherd Dr', fr: 'Ch. Greenbank et Prom. Strandherd', aoda: true},
        {en: 'Greenbank Rd & Marketplace Ave', fr: 'Ch. Greenbank et Av. Marketplace', aoda: true},
        {
            en: 'Greenbank Rd & Can. Tire Access / 220M N Of Strandherd',
            fr: 'Ch. Greenbank et Accès Au Canadian Tire / 220 M Nord De Prom. Strandherd',
            aoda: true,
        },
        {en: 'Greenbank Rd & Jockvale Rd', fr: 'Ch. Greenbank et Ch. Jockvale', aoda: false},
        {en: 'Grenon Ave & Richmond Rd', fr: 'Av. Grenon et Ch. Richmond', aoda: false},
        {en: 'Grey Nuns Dr & St Joseph Blvd', fr: 'Prom. Grey Nuns et Boul. St-Joseph', aoda: false},
        {
            en: 'Grey Nuns Dr/Youville Dr & Jeanne D\'Arc Blvd',
            fr: 'Prom. Grey Nuns / Prom. Youville et Boul. Jeanne-D\'Arc',
            aoda: false,
        },
        {en: 'Guy St/Rideau Hs & St Laurent Blvd', fr: 'Rue Guy / É. S. Rideau et Boul. St-Laurent', aoda: false},
        {en: 'Haig Dr & Smyth Rd', fr: 'Prom. Haig et Ch. Smyth', aoda: false},
        {en: 'Hampstead Pl & Walkley Rd', fr: 'Place Hampstead et Ch. Walkley', aoda: true},
        {en: 'Harmer Ave & Wellington St', fr: 'Av. Harmer et Rue Wellington', aoda: false},
        {
            en: 'Harness Lane/Willow Glen & Stonehaven Dr',
            fr: 'Rle Harness / Prom. Willow Glen et Prom. Stonehaven',
            aoda: false,
        },
        {en: 'Hawthorne Ave & Main St', fr: 'Av. Hawthorne et Rue Main', aoda: true},
        {en: 'Hawthorne Rd & Hunt Club Rd', fr: 'Ch. Hawthorne et Ch. Hunt Club', aoda: false},
        {en: 'Hawthorne Rd & Leitrim Rd', fr: 'Ch. Hawthorne et Ch. Leitrim', aoda: false},
        {en: 'Hazel St & Main St', fr: 'Rue Hazel et Rue Main', aoda: true},
        {en: 'Hazeldean Rd & Terry Fox Dr', fr: 'Ch. Hazeldean et Prom. Terry Fox', aoda: false},
        {
            en: 'Hazeldean Rd & Johnwoods St / Victor St',
            fr: 'Ch. Hazeldean et Rue Johnwoods / Rue Victor',
            aoda: false,
        },
        {
            en: 'Hazeldean Rd & Farm Boy Plaza / 246M E Of Castlefrank Rd',
            fr: 'Ch. Hazeldean et Farm Boy Plaza / 246 M Est Du Ch. Castlefrank',
            aoda: false,
        },
        {en: 'Hazeldean Rd & Springbrook Dr', fr: 'Ch. Hazeldean et Prom. Springbrook', aoda: false},
        {en: 'Hazeldean Rd & Huntmar Rd / Iber St', fr: 'Ch. Hazeldean et Ch. Huntmar / Rue Iber', aoda: false},
        {en: 'Hazeldean Rd & Stittsville Main St', fr: 'Ch. Hazeldean et Rue Stittsville Main', aoda: false},
        {
            en: 'Hazeldean Rd & Kittiwake Dr / Westridge Dr',
            fr: 'Ch. Hazeldean et Prom. Kittiwake / Prom. Westridge',
            aoda: false,
        },
        {
            en: 'Hazeldean Rd & 780M W Of Terry Fox Dr',
            fr: 'Ch. Hazeldean et 780 M Ouest De Prom. Terry Fox',
            aoda: false,
        },
        {en: 'Hazeldean Rd & 635M E Of Iber St', fr: 'Ch. Hazeldean et 635 M Est De Rue Iber', aoda: false},
        {en: 'Hazeldean Rd & 325M E Of Iber St', fr: 'Ch. Hazeldean et 325 M Est De Rue Iber', aoda: false},
        {
            en: 'Hazeldean Rd & 250M W Of Stittsville Main',
            fr: 'Ch. Hazeldean et 250 M Ouest De Rue Stittsville Main',
            aoda: false,
        },
        {en: 'Hazeldean Rd & 195W Of Carp Rd', fr: 'Ch. Hazeldean et 195 M Ouest Du Ch. Carp', aoda: false},
        {en: 'Heatherington Rd & Walkley Rd', fr: 'Ch. Heatherington et Ch. Walkley', aoda: true},
        {en: 'Heron Rd & Riverside Dr', fr: 'Ch. Heron et Prom. Riverside', aoda: false},
        {
            en: 'Heron Rd & Herongate Mall/Jefferson St',
            fr: 'Ch. Heron et C. C. Herongate / Rue Jefferson',
            aoda: false,
        },
        {en: 'Herzberg Rd & March Rd', fr: 'Ch. Herzberg et Ch. March', aoda: true},
        {en: 'Hincks & Riverside Dr', fr: 'Ruelle Hincks et Prom. Riverside', aoda: true},
        {
            en: 'Hobin/Wild Pine Crt & Stittsville Main St',
            fr: 'Rue Hobin / Cour Wild Pine et Rue Stittsville Main',
            aoda: false,
        },
        {en: 'Holland Ave & Wellington St', fr: 'Av. Holland et Rue Wellington', aoda: false},
        {en: 'Holland Ave & Tyndall St', fr: 'Av. Holland et Rue Tyndall', aoda: false},
        {en: 'Holland Ave & Kenilworth St', fr: 'Av. Holland et Rue Kenilworth', aoda: false},
        {
            en: 'Holland Ave & Fisher Park Ps / 95M N Of Sherwood Dr',
            fr: 'Av. Holland et É. P. Fisher Park / 95 M Nord De Prom. Sherwood',
            aoda: false,
        },
        {en: 'Holland Ave & Spencer St', fr: 'Av. Holland et Rue Spencer', aoda: false},
        {
            en: 'Holland Ave /Tunneys Pasture Ent & Scott St',
            fr: 'Av. Holland / Entrée Du Pré Tunney et Rue Scott',
            aoda: false,
        },
        {en: 'Holly Acres Rd & Transitway West', fr: 'Ch. Holly Acres et Transitway Ouest', aoda: true},
        {
            en: 'Holly Acres Rd /Nanaimo Dr & Richmond Rd',
            fr: 'Ch. Holly Acres /Prom. Nanaimo et Ch. Richmond',
            aoda: true,
        },
        {en: 'Hunt Club Rd & Uplands Dr', fr: 'Ch. Hunt Club et Prom. Uplands', aoda: true},
        {
            en: 'Hunt Club Rd & Paul Benoit Driveway / Royal Route',
            fr: 'Ch. Hunt Club et Prom. Paul Benoit / Route Royal',
            aoda: false,
        },
        {en: 'Hunt Club Rd & Paul Anka Dr', fr: 'Ch. Hunt Club et Prom. Paul Anka', aoda: false},
        {
            en: 'Hunt Club Rd & Lorry Greenberg Dr/ Sable Ridge Dr',
            fr: 'Ch. Hunt Club et Prom. Lorry Greenberg / Prom. Sable Ridge',
            aoda: false,
        },
        {en: 'Hunt Club Rd & Pike St', fr: 'Ch. Hunt Club et Rue Pike', aoda: false},
        {en: 'Hunt Club Rd & Prince Of Wales Dr', fr: 'Ch. Hunt Club et Prom. Prince Of Wales', aoda: false},
        {en: 'Hunt Club Rd & 225M E Of Riverside', fr: 'Ch. Hunt Club et 225 M Est De Prom. Riverside', aoda: false},
        {
            en: 'Hunters Run Dr/Henri Lauzon St & Jeanne D\'Arc Blvd',
            fr: 'Prom. Hunters Run / Rue Henri Lauzon et Boul. Jeanne-D\'Arc',
            aoda: false,
        },
        {en: 'Huntley Rd & Perth St', fr: 'Ch. Huntley et Rue Perth', aoda: false},
        {en: 'Huntmar Dr & Maple Grove Rd', fr: 'Prom. Huntmar et Ch. Maple Grove', aoda: false},
        {en: 'Huntsville Dr & Kanata Ave', fr: 'Prom. Huntsville et Av. Kanata', aoda: true},
        {
            en: 'Industrial Ave & Oc Transpo Garage Ent / 215M E Of Russel',
            fr: 'Av. Industrial et Entrée Du Oc Transpo / 215 M Est Du Ch. Russell',
            aoda: false,
        },
        {en: 'Industrial Ave & 385M E Of Trainyards', fr: 'Av. Industrial et 385 M Est De Trainyards', aoda: false},
        {en: 'Industrial Ave & Trainyards Dr', fr: 'Av. Industrial et Prom. Trainyards', aoda: false},
        {
            en: 'Industrial Ave /Innes Rd & St Laurent Blvd',
            fr: 'Av. Industrial / Ch. Innes et Boul. St-Laurent',
            aoda: true,
        },
        {
            en: 'Industrial Ave /Transitway & Riverside Dr',
            fr: 'Av. Industrial /Transitway et Prom. Riverside',
            aoda: false,
        },
        {en: 'Inglewood Pl & Parkdale Ave', fr: 'Place Inglewood et Av. Parkdale', aoda: false},
        {en: 'Innes Rd & Detention Centre', fr: 'Ch. Innes et Centre De Détention', aoda: true},
        {en: 'Innes Rd & Orient Park Dr', fr: 'Ch. Innes et Prom. Orient Park', aoda: false},
        {en: 'Innes Rd & Southpark Dr', fr: 'Ch. Innes et Prom. Southpark', aoda: false},
        {
            en: 'Innes Rd & Emily Carr M. Sch / 173M W Of Orient Park D',
            fr: 'Ch. Innes et É. Interm. Emily Carr / 173 M Ouest De Prom. Orient Park',
            aoda: false,
        },
        {en: 'Innes Rd & Stonehenge Cres W', fr: 'Ch. Innes et Crois. Stonehenge O.', aoda: false},
        {en: 'Innes Rd & Stonehenge Cres E', fr: 'Ch. Innes et Crois. Stonehenge E.', aoda: false},
        {
            en: 'Innes Rd & Home Depot Access / 215M W Of Cyrville Rd',
            fr: 'Ch. Innes et Accès Au Home Depot / 215 M Ouest Du Ch. Cyrville',
            aoda: false,
        },
        {
            en: 'Innes Rd & Jeanne D\'Arc Blvd / Mer Bleue Rd',
            fr: 'Ch. Innes et Boul. Jeanne-D\'Arc / Ch. Mer Bleue',
            aoda: false,
        },
        {en: 'Innes Rd & Orleans Blvd', fr: 'Ch. Innes et Boul. Orléans', aoda: false},
        {en: 'Innes Rd & Tenth Line Rd', fr: 'Ch. Innes et Ch. Tenth Line', aoda: false},
        {
            en: 'Innes Rd & Lanthier Dr / Prestwick Dr.',
            fr: 'Ch. Innes et Prom. Lanthier / Prom. Prestwick',
            aoda: false,
        },
        {
            en: 'Innes Rd & Bmr Access / 475M E Of Page',
            fr: 'Ch. Innes et Accès À Bmr / 475 M Est Du Ch. Pagé',
            aoda: false,
        },
        {en: 'Innes Rd & Portobello Blvd', fr: 'Ch. Innes et Boul. Portobello', aoda: false},
        {
            en: 'Innes Rd & Home Depot Access / 240M E Of Tenth Line Rd',
            fr: 'Ch. Innes et Accès Au Home Depot / 240 M Est Du Ch. Tenth Line',
            aoda: false,
        },
        {en: 'Innes Rd & Provence Rd', fr: 'Ch. Innes et Ch. Provence', aoda: false},
        {en: 'Innes Rd & Wildflower Dr', fr: 'Ch. Innes et Prom. Wildflower', aoda: true},
        {en: 'Innes Rd & Viseneau Dr', fr: 'Ch. Innes et Prom. Viseneau', aoda: false},
        {en: 'Innes Rd & 260M E Of Frank Bender St', fr: 'Ch. Innes et 260 M Est De La Rue Frank Bender', aoda: false},
        {en: 'Innes Rd & 298M E Of Wildflower', fr: 'Ch. Innes et 298 M Est De Prom. Wildflower', aoda: false},
        {en: 'Innes Rd & Trim Rd /Trim Rd', fr: 'Ch. Innes et Ch. Trim /Ch. Trim', aoda: true},
        {en: 'Innes Rd & Page Rd', fr: 'Ch. Innes et Ch. Pagé', aoda: false},
        {en: 'Innovation & Park N Ride', fr: 'Prom. Innovation et Parc-O-Bus', aoda: false},
        {en: 'Inverness St & Meadowlands Dr', fr: 'Rue Inverness et Prom. Meadowlands', aoda: false},
        {en: 'Iona St & Island Park Dr', fr: 'Rue Iona et Prom. Island Park', aoda: false},
        {en: 'Iris St & Woodroffe Ave', fr: 'Rue Iris et Av. Woodroffe', aoda: false},
        {
            en: 'Iris St & Pinecrest Sc/ 75M E Of Greenbank',
            fr: 'Rue Iris et C. C. Pinecrest / 75 M Est Du Ch. Greenbank',
            aoda: false,
        },
        {en: 'Iris St & Transitway Southwest', fr: 'Rue Iris et Transitway Sud-Ouest', aoda: false},
        {
            en: 'Iroquois Rd & Carlingwood Sc/118M N Of Carling Ave',
            fr: 'Ch. Iroquois et C. C. Carlingwood / 118 M Nord De L\'Av. Carling',
            aoda: false,
        },
        {en: 'Irwin Miller Street & Mcarthur Avenue', fr: 'Rue Irwin Miller et Av. Mcarthur', aoda: false},
        {
            en: 'Isabella St /Hwy 417 Eb Off Ramp & O\'Connor St',
            fr: 'Rue Isabella / Bretelle De Sortie Autoroute 417 Dir. E. et Rue O\'Connor',
            aoda: true,
        },
        {
            en: 'Isabella St /Hwy 417 Eb On Ramp & Metcalfe St',
            fr: 'Rue Isabella / Bretelle D\'Accès Autoroute 417 Dir. E. et Rue Metcalfe',
            aoda: false,
        },
        {
            en: 'Island Park Dr & Sir John A. Macdonlad Pkwy',
            fr: 'Prom. Island Park et Prom. Sir-John-A.-Macdonald',
            aoda: true,
        },
        {en: 'Island Park Dr & Scott St', fr: 'Prom. Island Park et Rue Scott', aoda: false},
        {en: 'Island Park Dr & Richmond Rd', fr: 'Prom. Island Park et Ch. Richmond', aoda: false},
        {en: 'Island Park Dr & Merivale Rd', fr: 'Prom. Island Park et Ch. Merivale', aoda: false},
        {
            en: 'Jeanne D\'Arc Blvd & Vorlage Dr/ Voyageur Dr',
            fr: 'Boul. Jeanne-D\'Arc et Prom. Vorlage/ Prom. Voyageur',
            aoda: true,
        },
        {en: 'Jeanne D\'Arc Blvd & Orleans Blvd N', fr: 'Boul. Jeanne-D\'Arc et Boul. Orléans N.', aoda: false},
        {
            en: 'Jeanne D\'Arc Blvd & Paddler Way/ Vorlage Dr',
            fr: 'Boul. Jeanne-D\'Arc et Voie Paddler / Prom. Vorlage',
            aoda: false,
        },
        {en: 'Jeanne D\'Arc Blvd & Montcerf Crt', fr: 'Boul. Jeanne-D\'Arc et Cour Montcerf', aoda: false},
        {
            en: 'Jeanne D\'Arc Blvd & Hwy 174 E/B Ramp',
            fr: 'Boul. Jeanne-D\'Arc et Bretelle Autoroute 174 Dir. E.',
            aoda: false,
        },
        {
            en: 'Jeanne D\'Arc Blvd & Hwy 174 W/B Ramp',
            fr: 'Boul. Jeanne-D\'Arc et Bretelle Autoroute 174 Dir. O.',
            aoda: false,
        },
        {en: 'Jeanne D\'Arc Blvd & Orleans Blvd S', fr: 'Boul. Jeanne-D\'Arc et Boul. Orléans S.', aoda: false},
        {
            en: 'Jeanne D\'Arc Blvd N & St Matthew Hs / 225M E Of Orleans',
            fr: 'Boul. Jeanne-D\'Arc N. et É. S. St Matthew / 225 M Est De Boul. Orléans',
            aoda: false,
        },
        {en: 'Jockvale Rd & Strandherd Dr', fr: 'Ch. Jockvale et Prom. Strandherd', aoda: false},
        {en: 'Jockvale Rd & 228M N Of Abetti Ridge', fr: 'Ch. Jockvale et 228 M Nord De Côte Abetti', aoda: false},
        {
            en: 'Jockvale Rd /Rideau Valley Dr & Prince Of Wales Dr',
            fr: 'Ch. Jockvale /Prom. Rideau Valley et Prom. Prince Of Wales',
            aoda: false,
        },
        {en: 'John Sutherland Dr/Ncc & Richmond Rd', fr: 'Prom. John Sutherland / Ccn et Ch. Richmond', aoda: false},
        {en: 'Johnston St & 65M W Of Allanford Ave', fr: 'Rue Johnston et 65 M Ouest De L\'Av. Allanford', aoda: false},
        {en: 'Joliffe St & St Laurent Blvd', fr: 'Rue Joliffe et Boul. St-Laurent', aoda: false},
        {en: 'Kanata Ave & Terry Fox Dr', fr: 'Av. Kanata et Prom. Terry Fox', aoda: false},
        {
            en: 'Kanata Ave & Lord Byng Way / Maritime Way',
            fr: 'Av. Kanata et Voie Lord Byng / Voie Maritime',
            aoda: false,
        },
        {en: 'Katimavik Rd & Whitney Dr', fr: 'Ch. Katimavik et Prom. Whitney', aoda: false},
        {
            en: 'Katimavik Rd/Palladium Dr & Terry Fox Dr',
            fr: 'Ch. Katimavik / Prom. Palladium et Prom. Terry Fox',
            aoda: true,
        },
        {en: 'Kennevale Rd & Strandherd Dr', fr: 'Ch. Kennevale et Prom. Strandherd', aoda: false},
        {en: 'Kent St & Slater St', fr: 'Rue Kent et Rue Slater', aoda: false},
        {en: 'Kent St & Somerset St W', fr: 'Rue Kent et Rue Somerset O.', aoda: false},
        {en: 'Kent St & Laurier Ave W', fr: 'Rue Kent et Av. Laurier O.', aoda: true},
        {en: 'Kent St & Queen St', fr: 'Rue Kent et Rue Queen', aoda: true},
        {en: 'Kent St & Nepean St', fr: 'Rue Kent et Rue Nepean', aoda: true},
        {
            en: 'Kimberwick Cres/Uplands Dr & Riverside Dr',
            fr: 'Crois Kimberwick / Prom. Uplands et Prom. Riverside',
            aoda: true,
        },
        {en: 'King Edward Ave & York St', fr: 'Av. King Edward et Rue York', aoda: false},
        {en: 'King Edward Ave & Laurier Ave E', fr: 'Av. King Edward et Av. Laurier E.', aoda: false},
        {en: 'King Edward Ave & Rideau St', fr: 'Av. King Edward et Rue Rideau', aoda: false},
        {
            en: 'King Edward Ave & Osgoode St/ Thomas More Drive',
            fr: 'Av. King Edward et Rue Osgoode / Prom. Thomas More',
            aoda: false,
        },
        {en: 'King Edward Ave & Wilbrod St', fr: 'Av. King Edward et Rue Wilbrod', aoda: false},
        {en: 'King Edward Ave & Stewart St', fr: 'Av. King Edward et Rue Stewart', aoda: false},
        {en: 'King Edward Ave & St Andrew St', fr: 'Av. King Edward et Rue St. Andrew', aoda: false},
        {en: 'King Edward Ave & St Patrick St', fr: 'Av. King Edward et Rue St-Patrick', aoda: false},
        {en: 'King Edward Ave & Sussex Dr', fr: 'Av. King Edward et Prom. Sussex', aoda: false},
        {en: 'King Edward Ave & Murray St', fr: 'Av. King Edward et Rue Murray', aoda: false},
        {en: 'King Edward Ave & Somerset St E', fr: 'Av. King Edward et Rue Somerset E.', aoda: false},
        {en: 'King Edward Ave /Lees Ave & Mann Ave', fr: 'Av. King Edward / Av. Lees et Av. Mann', aoda: true},
        {en: 'Kirkwood Ave & Laperriere Ave', fr: 'Av. Kirkwood et Av. Laperriere', aoda: false},
        {en: 'Kirkwood Ave & Merivale Rd', fr: 'Av. Kirkwood et Ch. Merivale', aoda: false},
        {en: 'Kirkwood Ave & Richmond Rd', fr: 'Av. Kirkwood et Ch. Richmond', aoda: false},
        {
            en: 'Kirkwood Ave & Hampton Court / 118M N Of Dovercourt Ave',
            fr: 'Av. Kirkwood et Cour Hampton / 118 M Nord De L\'Av. Dovercourt',
            aoda: false,
        },
        {en: 'Klondike Rd & Weatherston Dr', fr: 'Ch. Klondike et Prom. Weatherston', aoda: false},
        {
            en: 'Knoxdale Rd & Manordale Public School / 33M E Of Carola',
            fr: 'Ch. Knoxdale et École Publique Manordale / 33 M Est De Carola',
            aoda: false,
        },
        {en: 'Knoxdale Rd & Skipton Rd', fr: 'Ch. Knoxdale et Ch. Skipton', aoda: false},
        {
            en: 'Knoxdale Rd / Medhurst Dr & Woodroffe Ave',
            fr: 'Ch. Knoxdale / Prom. Medhurst et Av. Woodroffe',
            aoda: false,
        },
        {
            en: 'Kochar Dr / Normandy Cres & Prince Of Wales Dr',
            fr: 'Prom. Kochar / Crois. Normandy et Prom. Prince Of Wales',
            aoda: false,
        },
        {en: 'Lacasse Ave & Montreal Rd', fr: 'Av. Lacasse et Ch. De Montréal', aoda: true},
        {en: 'Lafontaine Ave & Mcarthur Ave', fr: 'Av. Lafontaine et Av. Mcarthur', aoda: false},
        {en: 'Lajoie St & Montreal Rd', fr: 'Rue Lajoie et Ch. De Montréal', aoda: false},
        {en: 'Lakepointe Dr & Tenth Line Rd', fr: 'Prom. Lakepointe et Ch. Tenth Line', aoda: false},
        {en: 'Lancaster Rd & Walkley Rd', fr: 'Ch. Lancaster et Ch. Walkley', aoda: false},
        {
            en: 'Lancaster Rd / Smyth Rd & Russell Rd / St Laurent Blvd',
            fr: 'Ch. Lancaster / Ch. Smyth et Ch. Russell / Boul. St-Laurent',
            aoda: false,
        },
        {en: 'Laurier Ave E & Nicholas St', fr: 'Av. Laurier E. et Rue Nicholas', aoda: false},
        {en: 'Laurier Ave E & Waller St / Transitway', fr: 'Av. Laurier E. et Rue Waller / Transitway', aoda: false},
        {en: 'Laurier Ave E & Nelson St', fr: 'Av. Laurier E. et Rue Nelson', aoda: false},
        {
            en: 'Laurier Ave E & U Of Ottawa / 73M E Of Waller St/Transitw',
            fr: 'Av. Laurier E. et Univ. D\'Ottawa / 73 M Est De Rue Waller/Transitway',
            aoda: true,
        },
        {en: 'Laurier Ave E & Sweetland Ave', fr: 'Av. Laurier E. et Av. Sweetland', aoda: false},
        {en: 'Laurier Ave W & Lyon St N', fr: 'Av. Laurier O. et Rue Lyon N.', aoda: false},
        {en: 'Laurier Ave W & O\'Connor St', fr: 'Av. Laurier O. et Rue O\'Connor', aoda: true},
        {en: 'Laurier Ave W & Metcalfe St', fr: 'Av. Laurier O. et Rue Metcalfe', aoda: false},
        {
            en: 'Laurier Ave W & Confederation Park /135M E Of Elgin St/ City Hall',
            fr: 'Av. Laurier O. et Parc De La Confédération /135 M Est De Rue Elgin/ Hôtel De Ville',
            aoda: false,
        },
        {en: 'Lees Ave & 342M E Of Chesnut St', fr: 'Av. Lees et 342 M Est De Rue Chesnut', aoda: true},
        {
            en: 'Lees Ave & Uottawa Access / 990M E Of Main St',
            fr: 'Av. Lees et Accès À Uottawa / 990 M Est De Rue Main',
            aoda: false,
        },
        {
            en: 'Legget Dr & Mitel Access / 300M W Of Schneider Rd',
            fr: 'Prom. Legget et Aacès À Mitel / 300 M Ouest Du Ch. Schneider',
            aoda: true,
        },
        {en: 'Legget Dr & Solandt Rd', fr: 'Prom. Legget et Ch. Solandt', aoda: false},
        {
            en: 'Leikin Dr & 150M N Of Bill Leathem / Rcmp Access',
            fr: 'Prom. Leikin et 150 M Nord De Bill Leathem / Accès À La Grc',
            aoda: false,
        },
        {en: 'Leitrim Rd & Limebank Rd', fr: 'Ch. Leitrim et Ch. Limebank', aoda: false},
        {en: 'Lemieux St & St Laurent Blvd', fr: 'Rue Lemieux et Boul. St-Laurent', aoda: false},
        {en: 'Lett St & Wellington St', fr: 'Rue Lett et Rue Wellington', aoda: false},
        {en: 'Limebank Rd & Spratt Rd', fr: 'Ch. Limebank et Ch. Spratt', aoda: false},
        {en: 'Limebank Rd/Riverside Dr & River Rd', fr: 'Ch. Limebank / Prom. Riverside et Ch. River', aoda: false},
        {en: 'Lisgar St & O\'Connor St', fr: 'Rue Lisgar et Rue O\'Connor', aoda: true},
        {en: 'Lisgar St & Metcalfe St', fr: 'Rue Lisgar et Rue Metcalfe', aoda: false},
        {
            en: 'Longfields Dr & 250M W Of Mountshannon/ Pierre Elliott Trudeau Hs',
            fr: 'Prom. Longfields et 250 M Ouest De Mountshannon / É. S. Pierre Elliott Trudeau',
            aoda: false,
        },
        {en: 'Longfields Dr & Strandherd Rd', fr: 'Prom. Longfields et Prom. Strandherd', aoda: false},
        {en: 'Longfields Dr & Woodroffe Ave', fr: 'Prom. Longfields et Av. Woodroffe', aoda: false},
        {
            en: 'Longfields Dr & Marketplace Ave / Clearbrook Dr',
            fr: 'Prom. Longfields et Av. Marketplace / Prom. Clearbrook',
            aoda: false,
        },
        {en: 'Longfields Dr & Chapman Mills Dr', fr: 'Prom. Longfields et Prom. Chapman Mills', aoda: true},
        {en: 'Longfields Dr & Paul Metivier Dr', fr: 'Prom. Longfields et Prom. Paul-Métivier', aoda: true},
        {
            en: 'Lorry Greenberg Dr & Roberta Bondar P. S. / 450M W Of Conroy Rd',
            fr: 'Prom. Lorry Greenberg et É. P. Roberta Bondar / 450 M Ouest Du Ch. Conroy',
            aoda: false,
        },
        {
            en: 'Lorry Greenberg Dr & 75M N Of Hunters Glen',
            fr: 'Prom. Lorry Greenberg et 75 M Nord Du Crois Hunters Glen',
            aoda: false,
        },
        {en: 'Lyndale Ave & Parkdale Ave', fr: 'Av. Lyndale et Av. Parkdale', aoda: false},
        {en: 'Lynhar Rd/Stafford Rd & Robertson Rd', fr: 'Ch. Lynhar / Ch. Stafford et Ch. Robertson', aoda: false},
        {en: 'Lyon St E Rdwy & Sparks St', fr: 'Chaussée E. Rue Lyon et Rue Sparks', aoda: false},
        {en: 'Lyon St N & Queen St', fr: 'Rue Lyon N. et Rue Queen', aoda: true},
        {en: 'Lyon St N & Wellington St', fr: 'Rue Lyon N. et Rue Wellington', aoda: false},
        {en: 'Lyon St W Rdwy & Sparks St', fr: 'Chaussée O. Rue Lyon et Rue Sparks', aoda: false},
        {en: 'Mackenzie Ave & Rideau St', fr: 'Av. Mackenzie et Rue Rideau', aoda: true},
        {en: 'Mackenzie Ave & Murray St', fr: 'Av. Mackenzie et Rue Murray', aoda: true},
        {
            en: 'Mackenzie Ave & York St Steps / 205M N Of Rideau St',
            fr: 'Av. Mackenzie et Marches De La Rue York / 205 M Nord De Rue Rideau',
            aoda: true,
        },
        {
            en: 'Mackenzie King Br & Dnd Entrance/ 250M W Of Nicholas',
            fr: 'Pont Mackenzie King et Entrée Du Mdn / 250 M Ouest De Rue Nicholas',
            aoda: false,
        },
        {
            en: 'Mackenzie King Br / Transitway & Nicholas St / Waller St',
            fr: 'Pont Mackenzie King / Transitway et Rue Nicholas / Rue Waller',
            aoda: false,
        },
        {en: 'Maclaren St & Metcalfe St', fr: 'Rue Maclaren et Rue Metcalfe', aoda: false},
        {en: 'Main St & Riverdale Ave', fr: 'Rue Main et Av. Riverdale', aoda: true},
        {
            en: 'Main St & Oblate Ave/ Immaculate H.S Ent',
            fr: 'Rue Main et Av. Oblate/ Entrée É. S. Immaculata',
            aoda: true,
        },
        {en: 'Majestic Dr & Woodroffe Ave', fr: 'Prom. Majestic et Av. Woodroffe', aoda: false},
        {en: 'Manotick Station Rd & Mitch Owens Rd', fr: 'Ch. Manotick Station et Ch. Mitch Owens', aoda: true},
        {en: 'Maple Grove Rd & Terry Fox Dr', fr: 'Ch. Maple Grove et Prom. Terry Fox', aoda: true},
        {en: 'Maravista Dr & Strandherd Dr', fr: 'Prom. Maravista et Prom. Strandherd', aoda: true},
        {en: 'March Rd & Solandt Rd', fr: 'Ch. March et Ch. Solandt', aoda: false},
        {en: 'March Rd & Teron Rd', fr: 'Ch. March et Ch. Teron', aoda: false},
        {
            en: 'March Rd & Morgan\'S Grant Way/ Shriley\'S Brook Dr',
            fr: 'Ch. March et Voie Morgan\'S Grant / Prom. Shriley\'S Brook',
            aoda: false,
        },
        {en: 'March Rd & Terry Fox Dr', fr: 'Ch. March et Prom. Terry Fox', aoda: false},
        {
            en: 'March Rd & Maxwell Bridge Rd / Halton Terr',
            fr: 'Ch. March et Ch. Maxwell Bridge / Terrasse Halton',
            aoda: false,
        },
        {en: 'March Rd & Old Second Line Rd', fr: 'Ch. March et Ch. Old Second Line', aoda: false},
        {en: 'March Rd & Klondike Rd', fr: 'Ch. March et Ch. Klondike', aoda: false},
        {en: 'March Rd & 250M N Of Klondike Rd', fr: 'Ch. March et 250 M Nord Du Ch. Klondike', aoda: false},
        {en: 'March Rd & Upper Dwyer Hill', fr: 'Ch. March et Ch. Upper Dwyer Hill', aoda: false},
        {en: 'Marguerite Ave & Mcarthur Ave', fr: 'Av. Marguerite et Av. Mcarthur', aoda: false},
        {en: 'Marier Ave & Montreal Rd', fr: 'Av. Marier et Ch. De Montréal', aoda: false},
        {en: 'Marketplace Ave & Transitway', fr: 'Av. Marketplace et Transitway', aoda: false},
        {en: 'May St & Mcarthur Ave', fr: 'Rue May et Av. Mcarthur', aoda: false},
        {en: 'Mcarthur Ave & North River Rd', fr: 'Av. Mcarthur et Ch. North River', aoda: false},
        {en: 'Mcarthur Ave & Olmstead St', fr: 'Av. Mcarthur et Rue Olmstead', aoda: false},
        {
            en: 'Mcarthur Ave & Moorevale / Rue De L\'Eglise',
            fr: 'Av. Mcarthur et Rue Moorevale / Rue De L\'Église',
            aoda: false,
        },
        {en: 'Mcarthur Ave & Vanier Pkwy', fr: 'Av. Mcarthur et Prom. Vanier', aoda: false},
        {en: 'Mcbean St & Perth St', fr: 'Rue Mcbean et Rue Perth', aoda: false},
        {en: 'Mccarthy Rd & Walkley Rd', fr: 'Ch. Maccarthy et Ch. Walkley', aoda: true},
        {en: 'Mccarthy Rd & Paul Anka Dr', fr: 'Ch. Maccarthy et Prom. Paul Anka', aoda: false},
        {en: 'Mccarthy Rd & Plante Dr N', fr: 'Ch. Maccarthy et Prom. Plante N.', aoda: false},
        {en: 'Mcleod St & O\'Connor St', fr: 'Rue Mcleod et Rue O\'Connor', aoda: true},
        {
            en: 'Mcrae Ave / Loblaws Access & Richmond Rd.',
            fr: 'Av. Mcrae / Accès Au Loblaws et Ch. Richmond.',
            aoda: false,
        },
        {
            en: 'Meadowbrook Rd & 170M W Of Telesat Crt',
            fr: 'Ch. Meadowbrook et 170 M Ouest De Cour Telesat',
            aoda: false,
        },
        {en: 'Meadowglen Dr & Orleans Blvd', fr: 'Prom. Meadowglen et Boul. Orléans', aoda: true},
        {en: 'Meadowlands Dr & Merivale Rd', fr: 'Prom. Meadowlands et Ch. Merivale', aoda: false},
        {en: 'Meadowlands Dr & Tiverton Dr', fr: 'Prom. Meadowlands et Prom. Tiverton', aoda: false},
        {en: 'Meadowlands Dr & Perry St / Peter Dr', fr: 'Prom. Meadowlands et Rue Perry / Prom. Peter', aoda: false},
        {
            en: 'Meadowlands Dr & 65M W Of Tatcher St',
            fr: 'Prom. Meadowlands et 65 M Ouest De Rue Tatcher',
            aoda: false,
        },
        {en: 'Meadowlands Dr & Viewmount Dr', fr: 'Prom. Meadowlands et Prom. Viewmount', aoda: false},
        {
            en: 'Meadowlands Dr /Tallwood & Woodroffe Ave',
            fr: 'Prom. Meadowlands / Prom. Tallwood et Av. Woodroffe',
            aoda: false,
        },
        {en: 'Meilleur Pvt & Vanier Pkwy', fr: 'Privé Meilleur et Prom. Vanier', aoda: false},
        {en: 'Melfort St & Walkley Rd', fr: 'Rue Melfort et Ch. Walkley', aoda: false},
        {en: 'Melrose Ave & Wellington St', fr: 'Av. Melrose et Rue Wellington', aoda: false},
        {
            en: 'Mer Bleue Rd & 210M S Of Innes / First Pro',
            fr: 'Ch. Mer Bleue et 210 M Sud Du Ch. Innes / First Pro',
            aoda: true,
        },
        {en: 'Merivale Rd & Summerville Ave', fr: 'Ch. Merivale et Av. Summerville', aoda: false},
        {en: 'Merivale Rd & Slack Rd', fr: 'Ch. Merivale et Ch. Slack', aoda: true},
        {en: 'Merivale Rd & Viewmount Dr', fr: 'Ch. Merivale et Prom. Viewmount', aoda: false},
        {en: 'Merivale Rd & Roydon Pl/ Woodfield Dr', fr: 'Ch. Merivale et Place Roydon/ Prom. Woodfield', aoda: true},
        {
            en: 'Merivale Rd & Plaza Ent / 210M S Of Meadowlands',
            fr: 'Ch. Merivale et Entrée De C. C. / 210 M Sud De Meadowlands',
            aoda: false,
        },
        {en: 'Merivale Rd & West Hunt Club Rd', fr: 'Ch. Merivale et Ch. West Hunt Club', aoda: true},
        {en: 'Merivale Rd & Prince Of Wales Dr', fr: 'Ch. Merivale et Prom. Prince Of Wales', aoda: true},
        {en: 'Merivale Rd & Shillington Ave', fr: 'Ch. Merivale et Av. Shillington', aoda: false},
        {
            en: 'Merivale Rd & Loblaws Superstore Access/ 145M W Of Burris Ln',
            fr: 'Ch. Merivale et Accès Au Loblaws Superstore / 145 M Ouest De Ruelle Burris',
            aoda: false,
        },
        {
            en: 'Merivale Rd & Westgate Sc Ent/ 115M N Of Carling',
            fr: 'Ch. Merivale et Entrée C. C. Westgate/ 115 M Nord De L\'Av. Carling',
            aoda: true,
        },
        {en: 'Merton Av & Scott St', fr: 'Av. Merton et Rue Scott', aoda: false},
        {en: 'Metcalfe St & Nepean St', fr: 'Rue Metcalfe et Rue Nepean', aoda: true},
        {en: 'Metcalfe St & Somerset St W', fr: 'Rue Metcalfe et Rue Somerset O.', aoda: false},
        {en: 'Metcalfe St & Wellington St', fr: 'Rue Metcalfe et Rue Wellington', aoda: false},
        {en: 'Metcalfe St & Slater St', fr: 'Rue Metcalfe et Rue Slater', aoda: false},
        {en: 'Miss Ottawa St & Montreal Rd', fr: 'Rue Miss Ottawa et Ch. De Montréal', aoda: false},
        {en: 'Montreal Rd & Ogilvie Rd', fr: 'Ch. De Montréal et Ch. Ogilvie', aoda: false},
        {en: 'Montreal Rd & St Laurent Blvd', fr: 'Ch. De Montréal et Boul. St-Laurent', aoda: false},
        {en: 'Montreal Rd & Vanier Pkwy', fr: 'Ch. De Montréal et Prom. Vanier', aoda: false},
        {
            en: 'Montreal Rd & Montreal Square Sc/ 245M E Of St. Laurent',
            fr: 'Ch. De Montréal Etc. C. Montreal Square / 245 M Est Du Boul. St-Laurent',
            aoda: false,
        },
        {en: 'Montreal Rd & Olmstead St', fr: 'Ch. De Montréal et Rue Olmstead', aoda: false},
        {en: 'Montreal Rd & Hwy 174 E/B Ramp', fr: 'Ch. De Montréal et Bretelle Autoroute 174 Dir. E.', aoda: false},
        {en: 'Montreal Rd & Sinclair St', fr: 'Ch. De Montréal et Rue Sinclair', aoda: false},
        {en: 'Montreal Rd & Monfort Hospital / Cmhc', fr: 'Ch. De Montréal et Hôpital Monfort / Schl', aoda: false},
        {en: 'Moodie Dr & Timm Rd', fr: 'Prom. Moodie et Ch. Timm', aoda: false},
        {en: 'Moodie Dr & Robertson Rd', fr: 'Prom. Moodie et Ch. Robertson', aoda: false},
        {
            en: 'Moodie Dr & Hwy 417 W/B Off Ramp',
            fr: 'Prom. Moodie et Bretelle De Sortie Autoroute 417 Dir. O.',
            aoda: true,
        },
        {
            en: 'Moodie Dr & Hwy 417 E/B Off Ramp',
            fr: 'Prom. Moodie et Bretelle De Sortie Autoroute 417 Dir. E.',
            aoda: false,
        },
        {en: 'Mooney\'S Bay Pl & Riverside Dr', fr: 'Place Mooney\'S Bay et Prom. Riverside', aoda: false},
        {en: 'Motreal Rd & Rue De L\'Eglise', fr: 'Ch. De Montréal et Rue De L\'Église', aoda: false},
        {en: 'Murray St & Sussex Dr', fr: 'Rue Murray et Prom. Sussex', aoda: false},
        {
            en: 'Navaho Dr & 265M E Of Woodroffe/ Algonquin College Ent',
            fr: 'Prom. Navaho et 265 M Est De L\'Av.Woodroffe / Entrée Collège Algonquin',
            aoda: false,
        },
        {en: 'Navaho Dr/ Transitway & Woodroffe Ave', fr: 'Prom. Navaho/ Transitway et Av. Woodroffe', aoda: false},
        {en: 'Navan Rd & Orleans Blvd', fr: 'Ch. Navan et Boul. Orléans', aoda: true},
        {en: 'Navan Rd & Renaud St', fr: 'Ch. Navan et Rue Renaud', aoda: false},
        {en: 'Navan Rd & Tenth Line Rd', fr: 'Ch. Navan et Ch. Tenth Line', aoda: false},
        {en: 'Nelson St & Rideau St', fr: 'Rue Nelson et Rue Rideau', aoda: false},
        {en: 'New Orchard Ave & Richmond Rd', fr: 'Av. New Orchard et Ch. Richmond', aoda: false},
        {en: 'Norice St & Woodroffe Ave', fr: 'Rue Norice et Av. Woodroffe', aoda: false},
        {
            en: 'Northside Rd/Stafford Centre Sc & Robertson Rd',
            fr: 'Ch. Northside /C. C. Stafford Centre et Ch. Robertson',
            aoda: false,
        },
        {en: 'O\'Connor St & Somerset St W', fr: 'Rue O\'Connor et Rue Somerset O.', aoda: true},
        {en: 'O\'Connor St & Wellington St', fr: 'Rue O\'Connor et Rue Wellington', aoda: false},
        {en: 'O\'Connor St & Slater St', fr: 'Rue O\'Connor et Rue Slater', aoda: false},
        {
            en: 'Ogilvie Rd & 190M E Of Elmridge / Jasmine / Lb Pearson P.S',
            fr: 'Ch. Ogilvie et 190 M Est De Elmridge / Jasmine / É. P. Lb Pearson',
            aoda: false,
        },
        {
            en: 'Ogilvie Rd & Trinity Centre / 185M E Of Bathgate Dr/City',
            fr: 'Ch. Ogilvie et Centre Trinity / 185 M Est De Prom. Bathgate/City',
            aoda: false,
        },
        {en: 'Ogilvie Rd & 125M E Of Elmlea Gate', fr: 'Ch. Ogilvie et 125 M Est De Porte Elmlea', aoda: false},
        {en: 'Ogilvie Rd & 240M W Of Blair Rd', fr: 'Ch. Ogilvie et 240 M Ouest Du Ch. Blair', aoda: false},
        {
            en: 'Old Richmond Rd & Our Lady Of Peace H S. / 170M S Of Kimberley',
            fr: 'Ch. Old Richmond et É. S. Our Lady Of Peace / 170 M Sud De Kimberley',
            aoda: false,
        },
        {
            en: 'Old Richmond Rd & Bells Corners Public School/ 65M S Of Robertson',
            fr: 'Old Ch. Richmond et École Publique Bells Corners / 65 M Sud Du Ch. Robertson',
            aoda: false,
        },
        {en: 'Old Richmond Rd & Robertson Rd', fr: 'Old Ch. Richmond et Ch. Robertson', aoda: false},
        {en: 'Old Richmond Rd & Seyton Dr', fr: 'Old Ch. Richmond et Prom. Seyton', aoda: false},
        {en: 'Old Richmond Rd & West Hunt Club Rd', fr: 'Old Ch. Richmond et Ch. West Hunt Club', aoda: false},
        {en: 'Old Second Line Rd & Terry Fox Dr', fr: 'Ch. Old Second Line et Prom. Terry Fox', aoda: true},
        {
            en: 'Old St Laurent Blvd & St Laurent Blvd Ext',
            fr: 'Ancien Boul. St-Laurent et Prolongement Boul. St-Laurent',
            aoda: false,
        },
        {
            en: 'Old Tenth Line Rd / Hwy 174 Eb Off Ramp & St Joseph Blvd',
            fr: 'Ch. Old Tenth Line / Bretelle De Sortie Autoroute 174 Dir. E. et Boul. St-Joseph',
            aoda: false,
        },
        {
            en: 'Orangeville St/Hwy 417 Eb Off Ramp & Rochester St',
            fr: 'Rue Orangeville / Bretelle De Sortie Autoroute 417 Dir. E. et Rue Rochester',
            aoda: false,
        },
        {en: 'Orleans Blvd & St Joseph Blvd', fr: 'Boul. Orléans et Boul. St-Joseph', aoda: false},
        {
            en: 'Otterson Dr/Springland Dr & Walkley Rd',
            fr: 'Prom. Otterson /Prom. Springland et Ch. Walkley',
            aoda: true,
        },
        {
            en: 'Palladium Dr & Hwy 417 W/B Off Ramp',
            fr: 'Prom. Palladium et Bretelle De Sortie Autoroute 417 Dir. O.',
            aoda: true,
        },
        {en: 'Palladium Dr & Silver Seven Rd', fr: 'Prom. Palladium et Ch. Silver Seven', aoda: false},
        {en: 'Pamilla St & Preston St', fr: 'Rue Pamilla et Rue Preston', aoda: false},
        {en: 'Parent Ave & St Patrick St', fr: 'Av. Parent et Rue St-Patrick', aoda: false},
        {en: 'Parkdale Ave & Sherwood Dr', fr: 'Av. Parkdale et Prom. Sherwood', aoda: false},
        {en: 'Parkdale Ave & Wellington St', fr: 'Av. Parkdale et Rue Wellington', aoda: false},
        {
            en: 'Parkdale Ave & Hwy 417 E/B On/Off Ramps',
            fr: 'Av. Parkdale et Bretelle D\'Accès et De Sortie Autoroute 417 Dir. E.',
            aoda: true,
        },
        {en: 'Parkdale Ave & Scott St', fr: 'Av. Parkdale et Rue Scott', aoda: false},
        {
            en: 'Parkdale Ave & Westmount Ave/ Hwy 417 Wb On Ramp',
            fr: 'Av. Parkdale et Av. Westmount/ Bretelle D\'Accès Autoroute 417 Dir. O.',
            aoda: true,
        },
        {en: 'Parkdale Ave & Ruskin St', fr: 'Av. Parkdale et Rue Ruskin', aoda: false},
        {en: 'Patricia Ave & Richmond Rd', fr: 'Av. Patricia et Ch. Richmond', aoda: true},
        {en: 'Pinecrest Rd & Richmond Rd', fr: 'Ch. Pinecrest et Ch. Richmond', aoda: false},
        {
            en: 'Pinecrest Rd & Hwy 417 W/B Off Ramp/ Transitway',
            fr: 'Ch. Pinecrest et Bretelle De Sortie Autoroute 417 Dir. O. / Transitway',
            aoda: false,
        },
        {
            en: 'Place D\'Orleans Dr E / Duford Dr & St Joseph Blvd',
            fr: 'Prom. Place D\'Orléans E. / Prom. Duford et Boul. St-Joseph',
            aoda: false,
        },
        {en: 'Place D\'Orleans Dr W & St Joseph Blvd', fr: 'Prom. Place D\'Orléans O. et Boul. St-Joseph', aoda: false},
        {en: 'Pleasant Park Rd & Riverside Dr', fr: 'Ch. Pleasant Park et Prom. Riverside', aoda: false},
        {en: 'Pleasant Park Rd & St Laurent Blvd', fr: 'Ch. Pleasant Park et Boul. St-Laurent', aoda: false},
        {
            en: 'Portobello/Springridge Dr S & Trim Rd',
            fr: 'Prom. Portobello/ Prom. Springridge S. et Ch. Trim',
            aoda: false,
        },
        {en: 'Presland Rd & Vanier Pkwy', fr: 'Ch. Presland et Prom. Vanier', aoda: false},
        {en: 'Preston St & Somerset St W', fr: 'Rue Preston et Rue Somerset O.', aoda: true},
        {
            en: 'Preston St & Prince Of Wales Dr / Queen Elizabeth Dr.',
            fr: 'Rue Preston et Prom. Prince Of Wales / Prom. Reine-Élizabeth',
            aoda: false,
        },
        {en: 'Prestone Dr & St Joseph Blvd', fr: 'Prom. Prestone et Boul. St-Joseph', aoda: false},
        {en: 'Prince Of Wales Dr & Strandherd Dr', fr: 'Prom. Prince Of Wales et Prom. Strandherd', aoda: false},
        {en: 'Prince Of Wales Dr & Amberwood Cres', fr: 'Prom. Prince Of Wales et Crois Amberwood', aoda: true},
        {
            en: 'Prince Of Wales Dr & Sir John A Carling Bldg/ 270M W Of Preston',
            fr: 'Prom. Prince Of Wales et Édifice Sir-John-A-Carling / 270 M Ouest De Rue Preston',
            aoda: false,
        },
        {
            en: 'Prince Of Wales Dr & Chateau Royale Access/ 215M N Of Hogs Back Rd',
            fr: 'Prom. Prince Of Wales et Accès À Chateau Royale / 215 M Nord Du Ch. Hog\'S Back',
            aoda: false,
        },
        {
            en: 'Prince Of Wales Dr & Waterbridge/Winding Way',
            fr: 'Prom. Prince Of Wales et Prom. Waterbridge / Voie Winding',
            aoda: true,
        },
        {en: 'Prince Of Wales Dr & Rocky Hill Dr', fr: 'Prom. Prince Of Wales et Prom. Rocky Hill', aoda: false},
        {
            en: 'Prince Of Wales Dr & Ncc Path / 300M S Of Amberwood Cres',
            fr: 'Prom. Prince Of Wales et Sentier De La Ccn / 300 M Sud Du Crois Amberwood',
            aoda: false,
        },
        {en: 'Queen Elizabeth Dr & Fifth Ave', fr: 'Prom. Reine-Élizabeth et Av. Fifth', aoda: false},
        {en: 'Queen Mary St & Vanier Pkwy', fr: 'Rue Queen Mary et Prom. Vanier', aoda: false},
        {
            en: 'Queensbury Dr/Rideaucrest Dr & Woodroffe Ave',
            fr: 'Prom. Queensbury / Prom. Rideaucrest et Av. Woodroffe',
            aoda: false,
        },
        {en: 'Railmarket Place & Trainyards Dr.', fr: 'Place Railmarket et Prom. Trainyards.', aoda: false},
        {
            en: 'Raymond St / Hwy 417 Wb On Ramp & Rochester St',
            fr: 'Rue Raymond / Bretelle D\'Accès Autoroute 417 Dir. O. et Rue Rochester',
            aoda: false,
        },
        {en: 'Research Rd / Ey Centre & Uplands Dr', fr: 'Ch. Research / Centre Ey et Prom. Uplands', aoda: false},
        {en: 'Richardson Side Rd & Terry Fox Dr', fr: 'Ch. Richardson Side et Prom. Terry Fox', aoda: false},
        {en: 'Richmond Rd & 140M E Of Poulin Ave', fr: 'Ch. Richmond et 140 M Est De L\'Av. Poulin', aoda: true},
        {en: 'Richmond Rd & 60M E Of Broadview Ave', fr: 'Ch. Richmond et 60 M Est De L\'Av. Broadview', aoda: false},
        {en: 'Richmond Rd & Woodroffe Ave', fr: 'Ch. Richmond et Av. Woodroffe', aoda: false},
        {en: 'Richmond Rd & Roosevelt Ave', fr: 'Ch. Richmond et Av. Roosevelt', aoda: false},
        {en: 'Rideau St & Waller St', fr: 'Rue Rideau et Rue Waller', aoda: false},
        {en: 'Rideau St & Wurtemburg St', fr: 'Rue Rideau et Rue Wurtemburg', aoda: false},
        {en: 'Rideau St & William Mall', fr: 'Rue Rideau et Mail William', aoda: false},
        {
            en: 'Rideau Valley Dr & Kars Public School / 36M S Of Commodore Dr',
            fr: 'Prom. Rideau Valley et École Publique Kars / 36 M Sud De Prom. Commodore',
            aoda: true,
        },
        {en: 'Ridgewood Ave & Riverside Dr', fr: 'Av.Ridgewood et Prom. Riverside', aoda: false},
        {en: 'Riocan Ave & Strandherd Dr', fr: 'Av. Riocan et Prom. Strandherd', aoda: false},
        {
            en: 'River Rd & 700M N Of Earl Armstrong Rd',
            fr: 'Ch. River et 700 M Nord Du Ch. Earl Armstrong',
            aoda: false,
        },
        {
            en: 'River Rd & 175M North Of Earl Armstrong Rd/ Independent',
            fr: 'Ch. River et 175 M Nord Du Ch. Earl Armstrong / Independent',
            aoda: false,
        },
        {en: 'River Rd & Tewsley Dr', fr: 'Ch. River et Prom. Tewsley Dr', aoda: false},
        {en: 'Rivergate Way & Riverside Dr', fr: 'Voie Rivergate et Prom. Riverside', aoda: false},
        {
            en: 'Riverside Dr & Hunt Club Marketplace / 175M S Of Hunt Club',
            fr: 'Prom. Riverside et Hunt Club Marketplace / 175 M Sud Du Ch. Hunt Club',
            aoda: false,
        },
        {en: 'Riverside Dr & Walkley Rd', fr: 'Prom. Riverside et Ch. Walkley', aoda: false},
        {en: 'Riverside Dr & Smyth Rd N Ramp', fr: 'Prom. Riverside et Bretelle N. Ch. Smyth', aoda: false},
        {en: 'Rochester St & Somerset St W', fr: 'Rue Rochester et Rue Somerset O.', aoda: false},
        {
            en: 'Roydon Place/Sunderland St & West Hunt Club Rd',
            fr: 'Place Roydonace/Rue Sunderland et Ch. West Hunt Club',
            aoda: true,
        },
        {en: 'Russell Rd & Walkley Rd', fr: 'Ch. Russell et Ch. Walkley', aoda: false},
        {en: 'Russell Rd & St Laurent Blvd Ext', fr: 'Ch. Russell et Prolongement Boul. St-Laurent', aoda: false},
        {en: 'Russell Rd & Southvale Cres N', fr: 'Ch. Russell et Crois Southvale N.', aoda: false},
        {en: 'Russell Rd & Tupper Ave', fr: 'Ch. Russell et Av. Tupper', aoda: false},
        {en: 'Saunderson Dr & Smyth Rd', fr: 'Prom. Saunderson et Ch. Smyth', aoda: false},
        {en: 'Saville Row & Woodroffe Ave', fr: 'Rang Saville et Av. Woodroffe', aoda: false},
        {en: 'Scott St & Tweedsmuir Ave', fr: 'Rue Scott et Av. Tweedsmuir', aoda: false},
        {en: 'Scott St & 40M E Of Smirle Ave', fr: 'Rue Scott et 40 M Est De L\'Av. Smirle', aoda: false},
        {en: 'Sheffield Rd & Walkley Rd', fr: 'Ch. Sheffield et Ch. Walkley', aoda: false},
        {
            en: 'Silver Seven Rd & Costco Entrance / 280M N Of Palladium',
            fr: 'Ch. Silver Seven et Entrée De Costco / 280 M Nord De Prom. Palladium',
            aoda: true,
        },
        {
            en: 'Sir John A. Macdonlad Pkwy & Lincoln Fields Transit Stn/ 270M N Of Carling Overpass',
            fr: 'Prom. Sir-John-A.-Macdonald et Station Lincoln Fields / 270 M Nord Passage Supérieur Carling',
            aoda: false,
        },
        {
            en: 'Sir John A. Macdonlad Pkwy & Transitway West',
            fr: 'Prom. Sir-John-A.-Macdonald et Transitway Ouest',
            aoda: false,
        },
        {
            en: 'Sir John A. Macdonlad Pkwy & River St/ Slidell St',
            fr: 'Prom. Sir-John-A.-Macdonald et Rue River /Rue Slidell',
            aoda: false,
        },
        {
            en: 'Sir John A. Macdonlad Pkwy & Preston St /Vimy Place',
            fr: 'Prom. Sir-John-A.-Macdonald et Rue Preston / Place Vimy',
            aoda: false,
        },
        {en: 'Slack Rd & Woodroffe Ave', fr: 'Ch. Slack et Av. Woodroffe', aoda: false},
        {
            en: 'Smyth Rd & General Hospital Ent/430M E Of South Haven Pl',
            fr: 'Ch. Smyth et Entrée Hôpital Général / 430 M Est De Place South Haven',
            aoda: false,
        },
        {en: 'Smyth Rd & Valour Dr', fr: 'Ch. Smyth et Prom. Valour', aoda: false},
        {en: 'Spratt Rd & 225M E Of Limebank Rd', fr: 'Ch. Spratt et 225 M Est Du Ch. Limebank', aoda: false},
        {en: 'St Jean St & St Joseph Blvd', fr: 'Rue St-Jean et Boul. St-Joseph', aoda: false},
        {
            en: 'St Laurent Blvd & Hwy 417 E/B Off Ramp',
            fr: 'Boul. St-Laurent et Bretelle De Sortie Autoroute 417 Dir. O.',
            aoda: true,
        },
        {en: 'St Laurent Blvd & 195M S Of Donald St', fr: 'Boul. St-Laurent et 195 M Sud De Rue Donald', aoda: false},
        {
            en: 'St Patrick St & Pedestrian Signal / 11M W Of Mackenzie Ave',
            fr: 'Rue St-Patrick et Feu Pour Piétons / 11 M Ouest De L\' Av. Mackenzie',
            aoda: true,
        },
        {en: 'St Patrick St & Sussex Dr', fr: 'Rue St-Patrick et Prom. Sussex', aoda: false},
        {en: 'Stanley Ave & Sussex', fr: 'Av. Stanley et Sussex', aoda: false},
        {
            en: 'Stittsville Main St & Mulkins St/Wintergreen Dr',
            fr: 'Rue Stittsville Main et Rue Mulkins / Prom. Wintergreen',
            aoda: false,
        },
        {
            en: 'Strandherd Dr & Barrhaven Town Centre/ 230M W Of Greenbank',
            fr: 'Prom. Strandherd et Barrhaven Town Centre/ 230 M Ouest Du Ch. Greenbank',
            aoda: false,
        },
        {en: 'Strandherd Dr & Woodroffe Ave', fr: 'Prom. Strandherd et Av. Woodroffe', aoda: false},
        {
            en: 'Strandherd Dr & 210M West Of Woodroffe',
            fr: 'Prom. Strandherd et 210 M Ouest De L\'Av. Woodroffe',
            aoda: false,
        },
        {en: 'Sussex Dr & York St', fr: 'Prom. Sussex et Rue York', aoda: false},
        {
            en: 'Sussex Dr & Old Ottawa City Hall / 160M E Of King Edward',
            fr: 'Prom. Sussex et Ancien Hôtel De Ville D\'Ottawa / 160 M Est De King Edward',
            aoda: false,
        },
        {
            en: 'Sussex Dr & Lester B Pearson Bldg Acc/ 160M W Of King Edward',
            fr: 'Prom. Sussex et Accès Édifice Lester B Pearson / 160 M Ouest De King Edward',
            aoda: false,
        },
        {en: 'Tenth Line Rd & Southfield Way', fr: 'Ch. Tenth Line et Voie Southfield', aoda: true},
        {
            en: 'Tenth Line Rd & 250M N Of Brian Coburn Blvd',
            fr: 'Ch. Tenth Line et 250 M Nord Du Boul. Brian Coburn',
            aoda: true,
        },
        {en: 'Tenth Line Rd & Harvest Valley Ave', fr: 'Ch. Tenth Line et Av. Harvest Valley', aoda: true},
        {
            en: 'Tenth Line Rd & 240M S Of Charlemagne Blvd',
            fr: 'Ch. Tenth Line et 240 M Sud Du Boul. Charlemagne',
            aoda: false,
        },
        {en: 'Tenth Line Rd & Vanguard Dr', fr: 'Ch. Tenth Line et Prom. Vanguard', aoda: true},
        {
            en: 'Tenth Line Rd & Fallingbrook Sc / 275M N Of Charlemagne Blvd',
            fr: 'Ch. Tenth Line et C. C. Fallingbrook / 27 M Nord Du Boul. Charlemagne',
            aoda: true,
        },
        {en: 'Terminal Rd & Trainyards Dr', fr: 'Ch. Terminal et Prom. Trainyards', aoda: false},
        {en: 'Terry Fox Dr & Park N Ride', fr: 'Prom. Terry Fox et Parc-O-Bus', aoda: true},
        {
            en: 'Terry Fox Dr & Hwy 417 W/B Off Ramp',
            fr: 'Prom. Terry Fox et Bretelle De Sortie Autoroute 417 Dir.O.',
            aoda: false,
        },
        {
            en: 'Terry Fox Dr & Restaurant Access / 240M S Of Edgewater',
            fr: 'Prom. Terry Fox et Accès Restaurant / 240 M Sud De Edgewater',
            aoda: false,
        },
        {
            en: 'Terry Fox Dr & Hwy 417 E/B Off Ramp',
            fr: 'Prom. Terry Fox et Bretelle De Sortie Autoroute 417 Dir. E.',
            aoda: false,
        },
        {en: 'Terry Fox Dr & Winchester Dr', fr: 'Prom. Terry Fox et Prom. Winchester', aoda: false},
        {en: 'Terry Fox Dr & Trans Canada Trail', fr: 'Prom. Terry Fox et Sentier Transcanadien', aoda: true},
        {
            en: 'Terry Fox Dr & 329M N Of Campeau Dr (Signature Centre)',
            fr: 'Prom. Terry Fox et 329 M Nord De Prom. Campeau (Signature Centre)',
            aoda: false,
        },
        {
            en: 'Terry Fox Dr & Sobey\'S / Mcdonalds Plaza/ 135M S Of Hazeldean',
            fr: 'Prom. Terry Fox et Sobey\'S / Mcdonalds Plaza / 135 M Sud Du Ch. Hazeldean',
            aoda: false,
        },
        {en: 'Terry Fox Dr & Huntsville Dr', fr: 'Prom. Terry Fox et Prom. Huntsville', aoda: true},
        {en: 'Terry Fox Dr & Westphalian', fr: 'Prom. Terry Fox et Av. Westphalian', aoda: false},
        {en: 'Trim Rd & Hwy 174', fr: 'Ch. Trim et Autoroute 174', aoda: true},
        {en: 'Trim Rd & Watters', fr: 'Ch. Trim et Ch. Watters', aoda: false},
        {en: 'Trim Rd & 150M S Of Innes', fr: 'Ch. Trim et 150 M Sud Du Ch. Innes', aoda: false},
        {en: 'Trim Rd & Valin St', fr: 'Ch. Trim et Rue Valin', aoda: false},
        {en: 'Trim Rd & 300M S Of Watters Rd', fr: 'Ch. Trim et 300 M Sud Du Ch. Watters', aoda: false},
        {
            en: 'Viewmount Dr & 140M W Of Chesterton Dr',
            fr: 'Prom. Viewmount et 140 M Ouest De Prom. Chesterton',
            aoda: false,
        },
        {
            en: 'Walkley Rd & Pedestrian Signal / 152M E Of Heatherington',
            fr: 'Ch. Walkley et Feu Pour Piétons / 15 M Est De Heatherington',
            aoda: false,
        },
        {en: 'Walkley Rd & 160M W Of Conroy Rd', fr: 'Ch. Walkley et 160 M Ouest Du Ch. Conroy', aoda: false},
        {en: 'Wellington St & Western Ave', fr: 'Rue Wellington et Av. Western', aoda: false},
        {
            en: 'West Hunt Club Rd & Recreation Path / 354M E Of Woodroffe Ave',
            fr: 'Ch. West Hunt Club et Sentier Récréatif / 354 M Est De L\'Av. Woodroffe',
            aoda: false,
        },
        {en: 'West Hunt Club Rd & Woodroffe Ave', fr: 'Ch. West Hunt Club et Av. Woodroffe', aoda: false},
        {
            en: 'West Hunt Club Rd & 545M E Of Roydon Pl / Sunderland St',
            fr: 'Ch. West Hunt Club et 545 M Est De Place Roydon / Rue Sunderland',
            aoda: false,
        },
        {
            en: 'Woodridge Cres N & Bayshore Public School/ 500M W Of Bayshore Dr',
            fr: 'Crois. Woodridge N. et École Publique Bayshore / 500 Ouest De Prom. Bayshore',
            aoda: false,
        },
        {
            en: 'Woodridge Cres S & Bayshore Sc / 220M W Of Bayshore Dr',
            fr: 'Crois. Woodridge S. et C. C. Bayshore / 220 M Ouest De Prom. Bayshore',
            aoda: false,
        },
        {
            en: 'Woodroffe Ave & Hwy 417 E/B Off Ramp',
            fr: 'Av. Woodroffe Etbretelle De Sortie Autoroute 417 Dir. E.',
            aoda: false,
        },
        {
            en: 'Woodroffe Ave & Transitway/Algonquin College Access',
            fr: 'Av. Woodroffe et Transitway / Accès Au Collège Algonquin',
            aoda: false,
        },
        {
            en: 'Woodroffe Ave & Nepean Sportsplex S Ent/ 225M S Of W. Hunt Club',
            fr: 'Av. Woodroffe et Entrée S. Sportsplex De Nepean / 225 M Ouest Du Ch. West Hunt Club',
            aoda: false,
        },
        {
            en: 'Woodroffe Ave & Fire Station 11 / 175M N Of Baseline Rd',
            fr: 'Av. Woodroffe et Caserne De Pompiers 11 / 175 M Nord Du Ch. Baseline',
            aoda: false,
        },
        {
            en: 'Woodroffe Ave & Carlingwood Sc/ 255M N Of Carling Ave',
            fr: 'Av. Woodroffe et C. C. Carlingwood / 255 M Nord De L\'Av. Carling',
            aoda: false,
        },
        {
            en: 'Woodroffe Ave & Nepean Sportsplex N Ent/ 220M S Of West Huntclub',
            fr: 'Av. Woodroffe et Entrée N. Sportsplex De Nepean / 220 M Nord Du Ch. West Huntclub',
            aoda: false,
        },
    ],
};
